

























































import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "@/commonComponents/header/header.vue";
import CanvasWindow from "./canvasWindow/canvasWindow.vue";
import TopController from "./topController/topController.vue";
// import ObjectListController from './objectListController/objectListController.vue';
import SubController from "./subController/subController.vue";
import RightController from "./rightController/rightController.vue";
import FileOpen from "@/commonComponents/fileOpen/fileOpen.vue";
import ContextMenu from "@/commonComponents/contextMenu/contextMenu.vue";
import DesignRenderer from "./designRenderer/designRenderer.vue";
import AddPage from "./addPageModal/addPageModal.vue";
import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue"
import Tutorial from "../tutorial/tutorial.vue";
import License from "../top2/mainContents/license/license.vue";
import IeAlertModal from "@/commonComponents/alertModal/ieAlertModal/ieAlertModal.vue";
import SaveDesignModal from "@/commonComponents/alertModal/saveDesignModal/saveDesignModal.vue";
import FontConvertModal from "@/commonComponents/alertModal/fontConvertModal/fontConvertModal.vue";
import SaveAttentionAlert from "@/commonComponents/alertModal/saveAttentionAlert/saveAttentionAlert.vue";
import LargeImageAlert from "@/commonComponents/alertModal/largeImageAlert/largeImageAlert.vue";
import AskConvert3dTextAlertModal from "@/commonComponents/alertModal/askConvert3dTextAlertModal/askConvert3dTextAlertModal.vue";

import * as def from "@/definitions";
import { Const } from '@/const'
import { ShortcutManager } from "@/model/shortcutManager/shortcutManager";
import { ClipboardManager } from "@/model/clipboardManager/clipboardManager";
// TODO document2
import { Document } from "@/model/document2/document";
import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";
import { CurveLayer } from "@/model/document2/page/surface/design/layer/curveLayer";
import { D3TextLayer } from "@/model/document2/page/surface/design/layer/d3TextLayer"
import { DateTextLayer } from "@/model/document2/page/surface/design/layer/dateTextLayer"
import { NumberLayer } from "@/model/document2/page/surface/design/layer/numberLayer"
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";
import { SpecialPatternLayer } from "@/model/document2/page/surface/design/layer/specialPatternLayer";
import { TextLayer } from "@/model/document2/page/surface/design/layer/textLayer";
import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer";
import { SimpleTextLayer } from "@/model/document2/page/surface/design/layer/simpleTextLayer";
import { PatternBaseLayer } from "@/model/document2/page/surface/design/layer/patternBaseLayer";
import { ImageLayer } from "@/model/document2/page/surface/design/layer/imageLayer";
import { TableLayer } from "@/model/document2/page/surface/design/layer/tableLayer";
import { UndoRedoManager } from "@/utilityModels/undoRedoManager";
import { TextInfo } from "@/utilityModels/textInfo";
import { ColorConstruct } from "@/utilityModels/colorConstruct";
import { Rectangle } from "@/utilityModels/rectangle";
import { Vector2 } from "@/utilityModels/vector2";
import { ProfileData } from "@/utilityModels/profileData";

// Command
import { NewLayerCommand } from "@/commands/newLayerCommand";
import { InsertLayerCommand } from "@/commands/insertLayerCommand";
import { TransformLayerCommand } from "@/commands/transformLayerCommand";
import { ChangeLayerPropertyCommand } from "@/commands/changeLayerPropertyCommand";
import { DeleteLayerCommand } from "@/commands/deleteLayerCommand";
import { MoveCurveControlPointCommand } from "@/commands/moveCurveControlPointCommand";
import { MovePolygonControlPointCommand } from "@/commands/movePolygonControlPointCommand";
import { ApplyPolygonControlPointsCommand } from "@/commands/applyPolygonControlPointsCommand";
import { NewDesignCommand } from "@/commands/newDesignCommand";
import { ChangePlainTextLayerWholeTextInfoCommand } from "@/commands/changePlainTextLayerWholeTextInfoCommand";
import { ChangePlainTextLayerRangeTextInfoCommand } from "@/commands/changePlainTextLayerRangeTextInfoCommand";
import { ChangeSimpleTextLayerTextInfoCommand } from "@/commands/changeSimpleTextLayerTextInfoCommand";
import { ChangeTextCommand } from "@/commands/changeTextCommand";
import { DuplicateLayerCommand } from "@/commands/duplicateLayerCommand";
import { AddControlPointToCurveCommand } from "@/commands/addControlPointToCurveCommand";
import { RemoveControlPointFromCurveCommand } from "@/commands/removeControlPointFromCurveCommand";
import { RotateDesignCommand } from "@/commands/rotateDesignCommand";
import { AddGradationOfPatternCommand } from "@/commands/addGradationOfPatternCommand";
import { RemoveGradationOfPatternCommand } from "@/commands/removeGradationOfPatternCommand";
import { ChangeGradationColorOfPatternCommand } from "@/commands/changeGradationColorOfPatternCommand";
import { ChangeGradationPositionOfPatternCommand } from "@/commands/changeGradationPositionOfPatternCommand";
import { ChangeTableCellInfoCommand } from "@/commands/changeTableCellInfoCommand";
import { AddTableCellCommand } from "@/commands/addTableCellCommand";
import { DeleteTableCellCommand } from "@/commands/deleteTableCellCommand";
import { NewPageCommand } from '@/commands/newPageCommand';
import { DuplicateLayerToSurfaceCommand } from '@/commands/duplicateLayerToSurfaceCommand'
import { InsertProfileCommand } from '@/commands/insertProfileCommand';
import { AddLayerCommand } from '@/commands/addLayerCommand';

import { ApplicationState } from "@/model/applicationState/applicationState";
import { CloudAccount } from "@/cloudAccount/cloudAccount";

// Helper
import { FileHelper } from "@/helper/fileHelper";
import { NameHelper } from '@/helper/nameHelper';
import { MathHelper } from '@/helper/mathHelper';
import { ArrayHelper } from '@/helper/arrayHelper';
import { PathHelper } from '@/helper/pathHelper';
import { ImageHelper } from '@/helper/imageHelper';
import { VectorImageLayer } from '@/model/document2/page/surface/design/layer/vectorImageLayer';
import { RasterImageLayer } from '@/model/document2/page/surface/design/layer/rasterImageLayer';
import { CookieHelper } from "@/helper/cookieHelper"
import { DateHelper } from "@/helper/dateHelper"
import { DocumentHelper } from '@/helper/documentHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { UuidHelper } from '@/helper/uuidHelper';
import { FontHelper } from '@/helper/fontHelper';
import { LogHelper } from "@/helper/logHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { StringHelper } from "@/helper/stringHelper";
import { NativeHelper } from '@/helper/nativeHelper';
import { LayerHelper } from "@/helper/layerHelper"

import { FileConverter } from "@/label_convert/fileConverter";
import { FontManager } from "@/model/fontManager/fontManager";

import WebFont from "webfontloader";

@Component({
  components: {
    Header,
    CanvasWindow,
    TopController,
    SubController,
    RightController,
    FileOpen,
    ContextMenu,
    DesignRenderer,
    AddPage,
    LoadingScreen,
    Tutorial,
    License,
    IeAlertModal,
    SaveDesignModal,
    FontConvertModal,
    SaveAttentionAlert,
    LargeImageAlert,
    AskConvert3dTextAlertModal
  }
})
export default class Edit extends Vue
{
    // フォントロードフラグ
    private isFontLoaded = false;

    //ローディングフラグ
    // private loading = false

    // チュートリアル表示フラグ
    isTutorial = false;
    // 使用規約許諾
    isLicense = false;
    // IEのアラート
    isIeAlertModal = false;

    // ショートカット無効フラグ
    // inputModeとは独立してショートカットを無効にする
    private isShorcutDisabled = false;

    private get paperInfoText() { return DocumentHelper.getPaperInfoText(this.currentDocument); }

    // レンダリング中フラグ
    private isRendering : boolean = false;

    exporting = false;

    // サムネイルレンダリング中フラグ
    private isRenderingThumbnail : boolean = false;

    // レンダリングクオリティ(pt -> pxに乗ずる値)
    private renderingQuality : number = 1;
    // レンダリング中レイヤーの描画範囲でクリップする
    private renderingClipLayer : boolean = false;
    // レンダリング開始
    private startRendering(quality : number, isClipLayer : boolean, isRenderingThumbnail : boolean = false)
    {
        this.exporting = true;
        this.renderingQuality = quality;
        this.renderingClipLayer = isClipLayer;
        this.isRenderingThumbnail = isRenderingThumbnail;
    }
    // レンダリング終了
    private endRendering()
    {
        this.exporting = false;
        this.isRenderingThumbnail = false;
    }

    // ズーム
    private zoomScale : number = 100;
    private isAutoZoom : boolean = true;

    // オブジェクトリネーム
    private renameId : string = "";

    // ショートカットキー、およびメニューのID
    static readonly MENU_COMMAND_COPY_SELECTED_LAYER = "design_editor_copy_selected_layer";
    static readonly MENU_COMMAND_CUT_SELECTED_LAYER = "design_editor_cut_selected_layer";
    static readonly MENU_COMMAND_PASTE_LAYER = "design_editor_paste_layer";
    static readonly MENU_COMMAND_SAVE_DOCUMENT = "design_editor_save_document";
    static readonly MENU_COMMAND_UNDO = "design_editor_undo";
    static readonly MENU_COMMAND_REDO = "design_editor_redo";
    static readonly MENU_COMMAND_GROUP_SELECTED_LAYER = "design_editor_group_selected_layer";
    static readonly MENU_COMMAND_UNGROUP_SELECTED_LAYER = "design_editor_ungroup_selected_layer";
    static readonly MENU_COMMAND_DELETE = "design_editor_delete";
    static readonly MENU_COMMAND_MOVE_LEFT = "design_editor_move_left";
    static readonly MENU_COMMAND_MOVE_TOP = "design_editor_move_top";
    static readonly MENU_COMMAND_MOVE_RIGHT = "design_editor_move_right";
    static readonly MENU_COMMAND_MOVE_BOTTOM = "design_editor_move_bottom";
    static readonly MENU_COMMAND_ZOOM_IN = "design_editor_zoom_in";
    static readonly MENU_COMMAND_ZOOM_OUT = "design_editor_zoom_out";
    static readonly MENU_COMMAND_MOVE_LEFT_10 = "design_editor_move_left_10";
    static readonly MENU_COMMAND_MOVE_TOP_10 = "design_editor_move_top_10";
    static readonly MENU_COMMAND_MOVE_RIGHT_10 = "design_editor_move_right_10";
    static readonly MENU_COMMAND_MOVE_BOTTOM_10 = "design_editor_move_bottom_10";
    static readonly MENU_COMMAND_ZOOM_100 = "design_editor_zoom_100";
    static readonly MENU_COMMAND_SELECT_ALL = "design_editor_select_all";

    // 待機
    private isWaiting = false;
    private get waitingTitle() { return "処理中"; }
    private get waitingMessage() { return "処理をしています…"; }

    // 最後に作成したsvgの内容
    private lastCreatedSvg = "";
    private lastCreatedSvgWidth = 0;
    private lastCreatedSvgHeight = 0;
    private lastCreatedSvgRotate = 0;

    // ヘッダーで画面から抜ける時の処理
    private onHeaderNavigationStart(link : string)
    {
        if(link == "/LayoutEditor" || link == "/PrintSetting" || link == "/" || link == "/SelectPage" || link == "/SelectTemplate")
        {
            // レイアウト、印刷に遷移する時に処理中表示
            this.isWaiting = true;
        }
    }

    private onHeaderNavigationFinish(link : string)
    {
        // 処理中を非表示
        this.isWaiting = false;
    }

    // 遷移処理
    // showWait : 待機モーダルを表示する
    private goLink(link : string, showWait : boolean = false)
    {
        if(showWait)
        {
            this.isWaiting = true;
            setTimeout(() =>
            {
                this.isWaiting = false;
                this.$router.push(link);
            }, 50);
        }
        else
        {
            this.$router.push(link);
        }
    }

    private mounted()
    {
        // ショートカット登録
        this.registerShortcut();
        document.addEventListener("keydown", this.onKeyDown);

        if(!CookieHelper.hasItem("isSubControllerVisible")){
            this.isSubControllerVisible = true;
        }else{
            this.isSubControllerVisible = CookieHelper.getItem("isSubControllerVisible")
        }

        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);

        if(UserAgentHelper.getBrowser() == "ie"
        && (!CookieHelper.hasItem("ieAlertShown") || CookieHelper.hasItem("ieAlertShown") && CookieHelper.getItem("ieAlertShown") == false)){
            this.isIeAlertModal = true;
        }
        else if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else if(CookieHelper.getItem("designEditorTutorial") != true){
            this.isTutorial = true;
        }

        if(UserAgentHelper.getBrowser() == "chrome" || UserAgentHelper.isElectron())
        {
            // Cut, Copy, Paste
            document.addEventListener("cut", this.onCut);
            document.addEventListener("copy", this.onCopy);
            document.addEventListener("paste", this.onPaste);
        }
    }

    private destroyed()
    {
        // ショートカット解除
        this.unregisterShortcut();
        document.removeEventListener("keydown", this.onKeyDown);

        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");

        if(UserAgentHelper.getBrowser() == "chrome" || UserAgentHelper.isElectron())
        {
            // Cut, Copy, Paste
            document.removeEventListener("cut", this.onCut);
            document.removeEventListener("copy", this.onCopy);
            document.removeEventListener("paste", this.onPaste);
        }

        // inputMode == 0にリセット
        this.changeInputMode(0);
    }

    // ヘッダーで遷移するときに呼び出す処理
    private onDisappearHeader(completion : () => void)
    {
        // 画像を更新
        this.isWaiting = true;
        this.updateCanvasImage(completion);
    }

    // ヘッダーのモーダル表示のときの処理
    private onHeaderModalAppeared()
    {
        this.isWaiting = false;
    }

    // コマンド処理
    // DL版で呼び出す
    private processExecCommand(parameterParent : any)
    {
        try
        {
            var command : string = parameterParent.command;
            var parameter : any = parameterParent.parameter;

            if(this.$store.getters.applicationState.inputMode != 0 && command != "update_text")
            {
                // inputMode == 0のときのみコマンド処理は許可する。ただしupdate_textは常に許可
                return;
            }

            if(command == "undo")
            {
                // アンドゥ
                this.undo();
            }
            else if(command == "redo")
            {
                // リドゥ
                this.redo();
            }
            else if(command == "cut")
            {
                // 切り取り
                this.cutSelectedLayer(true, true);
            }
            else if(command == "copy")
            {
                // コピー
                this.copySelectedLayer(true, true);
            }
            else if(command == "paste")
            {
                // 貼り付け
                this.pasteLayer();
            }
            else if(command == "delete")
            {
                // 削除
                this.deleteSelectedLayer();
            }
            else if(command == "unselect")
            {
                // 選択を解除
                this.unselectAllLayers();
            }
            else if(command == "select_all")
            {
                // すべてを選択
                this.selectAllLayers();
            }
            else if(command == "lock_layer")
            {
                // ロックの切り替え
                this.switchLockLayer();
            }
            else if(command == "group_layer")
            {
                // グループの切り替え
                this.switchGroupLayer();
            }
            else if(command == "bring_to_front_layer")
            {
                // レイヤーを最前面に
                this.bringToFrontCurrentLayer();
            }
            else if(command == "order_layer")
            {
                // レイヤーの順序変更
                this.orderLayer(parameter.direction);
            }
            else if(command == "bring_to_back_layer")
            {
                // レイヤーを最背面に
                this.sendToBackCurrentLayer();
            }
            else if(command == "align_layers")
            {
                // レイヤー整列
                this.alignSelectedLayers(parameter.direction, parameter.alignment);
            }
            else if(command == "switch_visible_sub_controller")
            {
                // サブコントローラの表示切り替え
                this.switchVisibleSubController();
            }
            else if(command == "switch_auto_zoom")
            {
                // 自動ズーム切り替え
                this.switchAutoZoom();
            }
            else if(command == "change_zoom_scale_by_step")
            {
                // ズーム変更
                this.changeZoomScaleByStep(parameter.direction == "up", true);
            }
            else if(command == "new_document")
            {
                // 新規ドキュメント
                this.createNewDocument();
            }
            else if(command == "import_document")
            {
                // ドキュメント読み込み
                let doc = FileHelper.loadDocumentAnyway(parameter.document);
                if(doc != null)
                {
                    let filePath = parameter.filePath;
                    let fileName = parameter.fileName != null ? parameter.fileName : "";

                    doc.currentFilePath = filePath;
                    doc.openedFileName = fileName;
                    var comp = () =>
                    {
                        // ドキュメントの準備
                        this.$store.getters.applicationState.preloadDocument = doc;
                        // 画面遷移
                        this.$router.push("/LayoutEditor");
                    };
                    // フォントコンバート対応
                    FontManager.applyUnloadedFontsToDocument(doc);
                    if(doc.unloadedFonts.length > 0)
                    {
                        // 利用できないフォントがあった場合
                        var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                        // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                        fontConvertModal.open(doc.unloadedFonts,
                        () =>
                        {
                            comp();
                        });
                    }
                    else
                    {
                        comp();
                    }
                }
            }
            else if(command == "import_label9_document")
            {
                // ラベル9ドキュメント読み込み
                let documentBuf = parameter.document;
                let filePath = parameter.filePath;
                let fileName = parameter.fileName != null ? parameter.fileName : "";

                // zip解凍
                let Unzip = require('zlibjs/bin/unzip.min').Zlib.Unzip;
                let uz = new Unzip(documentBuf);
                let filenames = uz.getFilenames();
                if(filenames && filenames.length > 0)
                {
                    // 最初のファイル(xml)
                    let decompressed = uz.decompress(filenames[0]);
                    let documentXml = StringHelper.utf8ArrayToStr(decompressed);
                    // ファイルコンバート
                    let fileConverter = new FileConverter(this.$store.getters.fontManager);
                    let doc = fileConverter.deserializeLabel9FromXml(documentXml);
                    if(doc != null)
                    {
                        doc.currentFilePath = filePath;
                        doc.openedFileName = fileName;

                        // 完了処理
                        let completion = () =>
                        {
                            if(doc == null) return;
                            let completion2 = () => {
                                if(doc == null) return;
                                // ドキュメントの準備
                                this.$store.getters.applicationState.preloadDocument = doc;
                                // 画面遷移
                                this.$router.push("/LayoutEditor");
                            }
                            // ラベル屋さん9の3D文字のコンバート対応
                            if(DocumentHelper.contains3dTextLayers(doc)) {
                                (this.$refs.askConvert3dTextAlertModal as AskConvert3dTextAlertModal).open(ret => {
                                    if(doc == null) return;
                                    if(ret) {
                                        DocumentHelper.convert3dTextLayersToSimpleTextLayers(doc);
                                    }
                                    completion2();
                                })
                            } else {
                                completion2();
                            }
                        };

                        if(doc.unloadedFonts.length > 0)
                        {
                            // 利用できないフォントがあった場合
                            var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                            // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                            fontConvertModal.open(doc.unloadedFonts,
                            () =>
                            {
                                if(doc != null) { completion(); }
                            });
                        }
                        else
                        {
                            completion();
                        }
                    }
                }
            }
            else if(command == "save_document_completed")
            {
                // ドキュメントの保存完了をネイティブから通知される
                if(this.isSaveDesignModalVisible)
                {
                    // 保存モーダル表示中であれば、完了処理を行う
                    this.saveDesignModalCompletion();
                }
                // ドキュメントのハッシュ更新
                this.currentDocument.updateHash();

                // 保存履歴送信
                LogHelper.sendLog("1000", {
                    productId : this.currentDocument.productId,
                    code : this.currentDocument.paperCode,
                    templateId : this.$store.getters.data.selectedTemplate.id,
                    cloud : 0
                });
            }
            else if(command == "print")
            {
                // 印刷
                // 画像更新処理中表示する
                this.isWaiting = true;
                this.updateCanvasImage(() =>
                {
                    // 完了したら印刷設定に遷移
                    this.goLink("/PrintSetting", true);
                });
            }
            else if(command == "export_image")
            {
                // 画像書き出し
                var topController = this.$refs.topController as TopController;
                topController.exportImage();
            }
            else if(command == "open_paper_info")
            {
                // 用紙情報を開く
                NativeHelper.sendNativeEvent("open_external_link", { url : Const.PRODUCT_DETAIL_URL_BASE + this.currentDocument.productCode });
            }
            else if(command == "update_text")
            {
                // テキスト更新が外からかかった
                var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
                canvasWindow.updateText();
            }
            else if(command == "save_to_cloud_document")
            {
                // クラウドへ保存
                this.$store.dispatch("setCloudOperation", this.$router.currentRoute.path);
                this.$store.dispatch("setCloudMode", "save");
                var cloudAccount = this.$store.getters.cloudAccount as CloudAccount;
                if(cloudAccount.isSignIn)
                {
                    this.$router.push("/cloud");
                }
                else
                {
                    this.$store.dispatch("setSignInToGo", "cloud");
                    this.$router.push("/signIn");
                }
            }
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
    }

    private registerShortcut()
    {
        // ショートカット登録
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        if(!UserAgentHelper.isElectron())
        {
            // Web版のみ
            if(!(UserAgentHelper.getBrowser() == "chrome" || UserAgentHelper.isElectron()))
            {
                manager.addKeyboardShortcut(Edit.MENU_COMMAND_COPY_SELECTED_LAYER, "ctrl", "c", () => this.executeCommand(Edit.MENU_COMMAND_COPY_SELECTED_LAYER), () => this.canExecuteCommand(Edit.MENU_COMMAND_COPY_SELECTED_LAYER));
                manager.addKeyboardShortcut(Edit.MENU_COMMAND_CUT_SELECTED_LAYER, "ctrl", "x", () => this.executeCommand(Edit.MENU_COMMAND_CUT_SELECTED_LAYER), () => this.canExecuteCommand(Edit.MENU_COMMAND_CUT_SELECTED_LAYER));
                manager.addKeyboardShortcut(Edit.MENU_COMMAND_PASTE_LAYER, "ctrl", "v", () => this.executeCommand(Edit.MENU_COMMAND_PASTE_LAYER), () => this.canExecuteCommand(Edit.MENU_COMMAND_PASTE_LAYER));
            }
            manager.addKeyboardShortcut(Edit.MENU_COMMAND_SAVE_DOCUMENT, "ctrl", "s", () => this.executeCommand(Edit.MENU_COMMAND_SAVE_DOCUMENT), () => this.canExecuteCommand(Edit.MENU_COMMAND_SAVE_DOCUMENT));
            manager.addKeyboardShortcut(Edit.MENU_COMMAND_UNDO, "ctrl", "z", () => this.executeCommand(Edit.MENU_COMMAND_UNDO), () => this.canExecuteCommand(Edit.MENU_COMMAND_UNDO));
            manager.addKeyboardShortcut(Edit.MENU_COMMAND_REDO, "ctrl + shift", "z", () => this.executeCommand(Edit.MENU_COMMAND_REDO), () => this.canExecuteCommand(Edit.MENU_COMMAND_REDO));
            manager.addKeyboardShortcut(Edit.MENU_COMMAND_GROUP_SELECTED_LAYER, "ctrl", "g", () => this.executeCommand(Edit.MENU_COMMAND_GROUP_SELECTED_LAYER), () => this.canExecuteCommand(Edit.MENU_COMMAND_GROUP_SELECTED_LAYER));
            manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_IN, "shift", ";", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_IN));
            manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_IN, "shift", "+", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_IN));
        }
        else
        {
            // Electronのみ
            manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_IN, "ctrl + shift", "-", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_IN));
            manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_IN, "ctrl + shift", "=", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_IN));
        }
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER, "ctrl + shift", "g", () => this.executeCommand(Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER), () => this.canExecuteCommand(Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_DELETE, "", "backspace", () => this.executeCommand(Edit.MENU_COMMAND_DELETE), () => this.canExecuteCommand(Edit.MENU_COMMAND_DELETE));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_DELETE, "", "delete", () => this.executeCommand(Edit.MENU_COMMAND_DELETE), () => this.canExecuteCommand(Edit.MENU_COMMAND_DELETE));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_LEFT, "", "ArrowLeft", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_LEFT), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_LEFT));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_TOP, "", "ArrowUp", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_TOP), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_TOP));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_RIGHT, "", "ArrowRight", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_RIGHT), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_RIGHT));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_BOTTOM, "", "ArrowDown", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_BOTTOM), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_BOTTOM));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_IN, "", "+", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_IN));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_OUT, "", "-", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_OUT), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_OUT));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_100, "ctrl", "1", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_100), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_100));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_LEFT_10, "shift", "ArrowLeft", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_LEFT_10), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_LEFT_10));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_TOP_10, "shift", "ArrowUp", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_TOP_10), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_TOP_10));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_RIGHT_10, "shift", "ArrowRight", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_RIGHT_10), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_RIGHT_10));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_BOTTOM_10, "shift", "ArrowDown", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_BOTTOM_10), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_BOTTOM_10));

        if(UserAgentHelper.isElectron() && UserAgentHelper.getBrowser() != "MacOS")
        {
            // ネイティブでWinのとき
            // なぜか　Ctrl + A でのレイヤー選択ができないので、Web側で実装する
            manager.addKeyboardShortcut(Edit.MENU_COMMAND_SELECT_ALL, "ctrl", "a", () => this.executeCommand(Edit.MENU_COMMAND_SELECT_ALL), () => this.canExecuteCommand(Edit.MENU_COMMAND_SELECT_ALL));
        }
    }

    // メニューコマンド処理
    private canExecuteCommand(key) : boolean
    {
        var canExecute = false;
        if(key == Edit.MENU_COMMAND_COPY_SELECTED_LAYER)
        {
            canExecute = this.copySelectedLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_CUT_SELECTED_LAYER)
        {
            canExecute = this.cutSelectedLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_PASTE_LAYER)
        {
            canExecute = this.pasteLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_SAVE_DOCUMENT)
        {
            canExecute = true;
        }
        else if(key == Edit.MENU_COMMAND_UNDO)
        {
            canExecute = this.undo(false);
        }
        else if(key == Edit.MENU_COMMAND_REDO)
        {
            canExecute = this.redo(false);
        }
        else if(key == Edit.MENU_COMMAND_GROUP_SELECTED_LAYER)
        {
            canExecute = this.groupSelectedLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER)
        {
            canExecute = this.ungroupSelectedLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_DELETE)
        {
            canExecute = this.deleteSelectedLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_MOVE_LEFT || key == Edit.MENU_COMMAND_MOVE_TOP || key == Edit.MENU_COMMAND_MOVE_RIGHT || key == Edit.MENU_COMMAND_MOVE_BOTTOM ||
            key == Edit.MENU_COMMAND_MOVE_LEFT_10 || key == Edit.MENU_COMMAND_MOVE_TOP_10 || key == Edit.MENU_COMMAND_MOVE_RIGHT_10 || key == Edit.MENU_COMMAND_MOVE_BOTTOM_10)
        {
            if(this.$store.getters.applicationState.dropdownListMode == 1)
            {
                // ドロップダウン表示中は項目選択を優先させるので無効
                canExecute = false;
            }
            else
            {
                if(this.currentDesign.selectLayers.length > 0 && this.currentDesign.currentLayer != null)
                {
                    if(this.currentDesign.currentLayer instanceof TextLayer && this.currentDesign.currentLayer.inEdit)
                    {
                        // テキスト編集中はキャレットの移動を優先させるので無効
                        canExecute = false;
                    }
                    else
                    {
                        // すべての選択レイヤーがロックされている場合は無効
                        var allLocked = true;
                        for(var i = 0; i < this.currentDesign.selectLayers.length; ++i)
                        {
                            if(!this.currentDesign.selectLayers[i].isLocked) { allLocked = false; }
                        }
                        canExecute = !allLocked;
                    }
                }
            }
        }
        else if(key == Edit.MENU_COMMAND_ZOOM_IN || key == Edit.MENU_COMMAND_ZOOM_OUT)
        {
            if(this.isInTextEdit())
            {
                // キーボード操作と文字入力がバッティングするので無効
                canExecute = false;
            }
            else
            {
                canExecute = this.changeZoomScaleByStep(key == Edit.MENU_COMMAND_ZOOM_IN, true, false);
            }
        }
        else if(key == Edit.MENU_COMMAND_ZOOM_100)
        {
            if(this.isInTextEdit())
            {
                // キーボード操作と文字入力がバッティングするので無効
                canExecute = false;
            }
            else
            {
                canExecute = true;
            }
        }
        else if(key == Edit.MENU_COMMAND_SELECT_ALL)
        {
            canExecute = this.selectAllLayers(false);
        }

        return canExecute;
    }

    private executeCommand(key) : void
    {
        if(key == Edit.MENU_COMMAND_COPY_SELECTED_LAYER)
        {
            this.copySelectedLayer(true, true);
        }
        else if(key == Edit.MENU_COMMAND_CUT_SELECTED_LAYER)
        {
            this.cutSelectedLayer(true, true);
        }
        else if(key == Edit.MENU_COMMAND_PASTE_LAYER)
        {
            this.pasteLayer();
        }
        else if(key == Edit.MENU_COMMAND_SAVE_DOCUMENT)
        {
            this.saveDocument();
        }
        else if(key == Edit.MENU_COMMAND_UNDO)
        {
            this.undo();
        }
        else if(key == Edit.MENU_COMMAND_REDO)
        {
            this.redo();
        }
        else if(key == Edit.MENU_COMMAND_GROUP_SELECTED_LAYER)
        {
            this.groupSelectedLayer();
        }
        else if(key == Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER)
        {
            this.ungroupSelectedLayer();
        }
        else if(key == Edit.MENU_COMMAND_DELETE)
        {
            this.deleteSelectedLayer();
        }
        else if(key == Edit.MENU_COMMAND_MOVE_LEFT || key == Edit.MENU_COMMAND_MOVE_TOP || key == Edit.MENU_COMMAND_MOVE_RIGHT || key == Edit.MENU_COMMAND_MOVE_BOTTOM)
        {
            // 全ての選択レイヤーのうち、ロックされていないレイヤーを移動する
            var selectedLayers = this.currentDesign.selectLayers;
            for(var i = 0; i < selectedLayers.length; ++i)
            {
                var selectedLayer = selectedLayers[i];
                if(selectedLayer.isLocked) { continue; }
                var newX = selectedLayer.x;
                var newY = selectedLayer.y;
                if(key == Edit.MENU_COMMAND_MOVE_LEFT) { newX -= 1.0; }
                else if(key == Edit.MENU_COMMAND_MOVE_TOP) { newY -= 1.0; }
                else if(key == Edit.MENU_COMMAND_MOVE_RIGHT) { newX += 1.0; }
                else if(key == Edit.MENU_COMMAND_MOVE_BOTTOM) { newY += 1.0; }
                this.transformLayer(selectedLayer, newX, newY, selectedLayer.width, selectedLayer.height, selectedLayer.rotate, false);
            }
            this.fixMultiCommand();
        }
        else if(key == Edit.MENU_COMMAND_ZOOM_IN || key == Edit.MENU_COMMAND_ZOOM_OUT)
        {
            if(this.isInTextEdit())
            {
                // キーボード操作と文字入力がバッティングするので無効
                return;
            }
            else
            {
                this.changeZoomScaleByStep(key == Edit.MENU_COMMAND_ZOOM_IN, true, true);
            }
        }
        else if(key == Edit.MENU_COMMAND_ZOOM_100)
        {
            if(this.isInTextEdit())
            {
                // キーボード操作と文字入力がバッティングするので無効
                return;
            }
            else
            {
                // 100%に設定
                this.changeZoomScale(100, true);
            }
        }
        else if(key == Edit.MENU_COMMAND_MOVE_LEFT_10 || key == Edit.MENU_COMMAND_MOVE_TOP_10 || key == Edit.MENU_COMMAND_MOVE_RIGHT_10 || key == Edit.MENU_COMMAND_MOVE_BOTTOM_10)
        {
            // 全ての選択レイヤーのうち、ロックされていないレイヤーを移動する
            var selectedLayers = this.currentDesign.selectLayers;
            for(var i = 0; i < selectedLayers.length; ++i)
            {
                var selectedLayer = selectedLayers[i];
                if(selectedLayer.isLocked) { continue; }
                var newX = selectedLayer.x;
                var newY = selectedLayer.y;
                if(key == Edit.MENU_COMMAND_MOVE_LEFT_10) { newX -= 10.0; }
                else if(key == Edit.MENU_COMMAND_MOVE_TOP_10) { newY -= 10.0; }
                else if(key == Edit.MENU_COMMAND_MOVE_RIGHT_10) { newX += 10.0; }
                else if(key == Edit.MENU_COMMAND_MOVE_BOTTOM_10) { newY += 10.0; }
                this.transformLayer(selectedLayer, newX, newY, selectedLayer.width, selectedLayer.height, selectedLayer.rotate, false);
            }
            this.fixMultiCommand();
        }
        else if(key == Edit.MENU_COMMAND_SELECT_ALL)
        {
            this.selectAllLayers();
        }
    }

    private unregisterShortcut()
    {
        // ショートカット解除
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_COPY_SELECTED_LAYER);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_CUT_SELECTED_LAYER);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_PASTE_LAYER);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_SAVE_DOCUMENT);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_UNDO);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_REDO);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_GROUP_SELECTED_LAYER);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_DELETE);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_LEFT);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_TOP);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_RIGHT);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_BOTTOM);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_IN);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_OUT);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_100);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_LEFT_10);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_TOP_10);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_RIGHT_10);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_BOTTOM_10);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_SELECT_ALL);
    }

    private onKeyDown(event)
    {
        // ショートカット実行
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        var applicationState = this.$store.getters.applicationState as ApplicationState;
        if(applicationState.inputMode == 0 && !this.isShorcutDisabled)
        {
            // ショートカットは入力状態がなしのときのみ有効
            manager.doKeyboardShortcutIfNeeded(event);

            if(UserAgentHelper.getBrowser() == "ie")
            {
                // IEでBackspaceによる「戻る」を封じる
                if(event.key == "Backspace" && event.defaultPrevented != true)
                {
                    DebugHelper.trace("IE: Backspace is not allowed.");
                    event.preventDefault();
                }
            }
        }

        // IEでBackspaceによる「戻る」が封じきれないことがあるのでここでも確認
        if(UserAgentHelper.getBrowser() == "ie" && event.defaultPrevented != true)
        {
            DebugHelper.trace(event.target);
            var focusElement = document.activeElement;
            if(focusElement != null)
            {
                var focusTagName = focusElement.tagName.toLowerCase();
                if(focusTagName != "input" && focusTagName != "textarea")
                {
                    // input, textarea 以外でのデフォルトのBackspace動作は封じる
                    DebugHelper.trace("IE: Backspace is not allowed. : Not input or textarea");
                    event.preventDefault();
                }
            }
        }

    }

    private onCut(event)
    {
        // テキスト入力中 or アプリケーションモード0以外はデフォルトに任せる
        if(this.isInTextEdit() || this.$store.getters.applicationState.inputMode != 0) { return; }

        if(this.cutSelectedLayer())
        {
            // クリップボードをクリアする
            event.clipboardData.clearData();
            event.clipboardData.setData("text/plain", "");
            event.preventDefault();
        }
    }

    private onCopy(event)
    {
        // テキスト入力中 or アプリケーションモード0以外はデフォルトに任せる
        if(this.isInTextEdit() || this.$store.getters.applicationState.inputMode != 0) { return; }

        if(this.copySelectedLayer())
        {
            // クリップボードをクリアする
            event.clipboardData.clearData();
            event.clipboardData.setData("text/plain", "");
            event.preventDefault();
        }
    }

    private onPaste(event)
    {
        // テキスト入力中 or アプリケーションモード0以外はデフォルトに任せる
        if(this.isInTextEdit() || this.$store.getters.applicationState.inputMode != 0) { return; }

        event.preventDefault();

        let items = event.clipboardData.items;
        let isClipBoardPasted = false;

        // クリップボードに画像データがあるか？
        for(let i = 0; i < items.length; ++i)
        {
            if(items[i].type.indexOf("image") != -1)
            {
                let dti = items[i];
                if(dti && dti.getAsFile)
                {
                    // 画像データがある
                    // イメージからBlobを取得
                    let blob = dti.getAsFile();
                    // Blobが取得できない場合は次へ
                    if(blob == null) continue;
                    // Blob -> base64
                    let reader = new FileReader();
                    reader.onload = () =>
                    {
                        let imageBase64 = reader.result;
                        // クリップボードに登録
                        this.$store.getters.clipboardManager.setImageData(imageBase64, this.currentDesign, () =>
                        {
                            // クリップボードが更新された状態で貼り付けを実行する
                            this.pasteLayer();
                        });
                    };
                    reader.readAsDataURL(blob);
                    DebugHelper.trace("[ctrl+v]image data in clipboard is pasted.");
                    isClipBoardPasted = true;
                    break;
                }
            }
        }

        if(!isClipBoardPasted)
        {
            // 画像データが貼り付けされなかった -> レイヤー貼り付け
            DebugHelper.trace("[ctrl+v]no image data in clipboard. -> paste layer.");
            this.pasteLayer();
        }
    }

    private get currentDocument() : Document
    {
        return this.$store.getters.document;
    }

    private get documentRotate()
    {
        return this.currentDocument.rotate;
    }

    private get clipboardManager() : ClipboardManager
    {
        return this.$store.getters.clipboardManager;
    }

    private get currentPage()
    {
        var document = this.currentDocument;
        return document.pageList[document.currentPageIndex];
    }

    private get currentDesign() : Design
    {
      	return this.$store.getters.design;
	}

    private get currentLayer() : Layer | null
    {
      	return this.currentDesign.currentLayer;
    }

    private get isReverseSurface()
    {
        return this.currentDocument.isReverseSurface;
    }

    // テキスト編集中か取得
    private isInTextEdit()
    {
        return this.currentLayer != null && this.currentLayer instanceof TextLayer && this.currentLayer.inEdit;
    }

	// すべてのデザインへの編集は、このクラスから行う
	// action - mutation モデルへの移行も視野に入れている

	// コマンドのコール
	private onDoCommand(command : string, parameter : any)
	{
     	if(command == "newLayer")
		{
			this.newLayer(parameter.newLayer, parameter.parent);
        }
        else if (command === 'newGroupLayerWithSelection')
        {
            this.newGroupLayerWithSelection();
        }
        else if(command == "newTextLayer")
        {
            // テキストレイヤーはサイズ調整が必要なものがあるので別に扱う
            this.newTextLayer(parameter.newLayer, parameter.parent);
        }
		else if(command == "transformLayer")
		{
			this.transformLayer(parameter.layer, parameter.x, parameter.y, parameter.width, parameter.height,
				parameter.rotate, parameter.isFinish);
		}
		else if(command == "changeCurrentLayer")
		{
            if(this.currentLayer != parameter.layer)
            {
                // カレントレイヤーが変更するとき、変形モードリセット
                this.changeEditMode(0);
            }
			this.changeCurrentLayer(parameter.layer);
        }
        else if(command == "selectLayer")
        {
            this.selectLayer(parameter.layer, parameter.isSelect);
        }
        else if(command == "changeSelectLayers")
        {
            this.changeSelectLayers(parameter.layers);
        }
        else if(command === 'appendLayerSelection')
        {
            this.appendLayerSelection(parameter.layer);
        }
        else if(command === 'removeLayerSelection')
        {
            this.removeLayerSelection(parameter.layer);
        }
        else if(command == "moveLayer")
        {
            this.moveLayer(parameter.layer, parameter.x, parameter.y, parameter.isFinish);
        }
        else if(command == "resizeLayer")
        {
            this.resizeLayer(parameter.layer, parameter.width, parameter.height, parameter.isFinish);
        }
        else if(command == "rotateLayer")
        {
            this.rotateLayer(parameter.layer, parameter.rotate, parameter.isFinish);
        }
        else if(command == "changeLayerProperty")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? false : parameter.isOnce;
            this.changeLayerProperty(parameter.layer, parameter.propertyName, parameter.value, isFinish, isOnce);
        }
        else if(command == "changePlainTextLayerWholeTextInfo")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? false : parameter.isOnce;
            this.changePlainTextLayerWholeTextInfo(parameter.layer, parameter.propertyName, parameter.value, isFinish, isOnce);
        }
        else if(command == "changePlainTextLayerRangeTextInfo")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? false : parameter.isOnce;
            this.changePlainTextLayerRangeTextInfo(parameter.layer, parameter.textInfoArray, parameter.startPosition, parameter.endPosition, isFinish, isOnce);
        }
        else if(command == "changeSimpleTextLayerTextInfo")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? false : parameter.isOnce;
            this.changeSimpleTextLayerTextInfo(parameter.layer, parameter.propertyName, parameter.value, isFinish, isOnce);
        }
        else if(command == "moveCurveControlPoint")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.moveCurveControlPoint(parameter.layer, parameter.index, parameter.x, parameter.y, isFinish);
        }
        else if(command == "movePolygonControlPoint")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.movePolygonControlPoint(parameter.layer, parameter.index, parameter.x, parameter.y, isFinish);
        }
        else if(command == "applyPolygonControlPoints")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? true : parameter.isOnce;
            this.applyPolygonControlPoints(parameter.layer, parameter.points, isFinish, isOnce);
        }
        else if(command == "dupilicateLayerToSurface")
        {
            // 面へレイヤー複製
            this.duplicateLayerToSurface(parameter.layer, parameter.isReverse);
        }
        else if(command == "deleteLayer")
        {
            this.deleteLayer(parameter.deleteLayer);
        }
        else if(command == "toLayout")
        {
            // 変形モード解除
            this.changeEditMode(0);

            var flowMode = this.$store.getters.applicationState.flowMode;
            if(flowMode == 1 || flowMode == 2 || flowMode == 3)
            {
                // 差し込みに遷移させる
                this.toInsertion();
            }
            else
            {
                this.toLayout();
            }
        }
        else if(command == "changeSurface")
        {
            this.changeSurface(parameter.isReverse);
        }
        else if(command == "changeText")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeText(parameter.layer, parameter.text, parameter.isFinish);
        }
        else if(command == "fixMultiCommand")
        {
            this.fixMultiCommand();
        }
        else if(command == "changeZoomScale")
        {
            // ズーム倍率変更
            var isAutoZoomOff = (parameter.isAutoZoomOff != null) ? parameter.isAutoZoomOff : false;
            this.changeZoomScale(parameter.scale, isAutoZoomOff);
        }
        else if(command == "changeAutoZoom")
        {
            // 自動ズーム切り替え
            this.changeAutoZoom(parameter.isAutoZoom);
        }
        else if(command == "moveLayerPosition")
        {
            this.moveLayerPosition(parameter.layers, parameter.toLayer, parameter.placement);
        }
        else if(command == "showContextMenu")
        {
            // コンテキストメニュー表示
            this.showContextMenu(parameter.event, parameter.type);
        }
        else if(command == "hideContextMenu")
        {
            // コンテキストメニュー非表示
            this.hideContextMenu();
        }
        else if(command == "changeCurveEditMode")
        {
            // 曲線編集モード変更
            this.changeCurveEditMode(parameter.mode);
        }
        else if(command == "changeEditMode")
        {
            // 編集モード変更
            this.changeEditMode(parameter.mode);
        }
        else if(command == "addControlPointToCurve")
        {
            // 曲線に制御点追加
            this.addControlPointToCurve(parameter.layer, parameter.index, parameter.x, parameter.y);
        }
        else if(command == "removeControlPointFromCurve")
        {
            // 曲線の制御点削除
            this.removeControlPointFromCurve(parameter.layer, parameter.index);
        }
        else if(command == "rotateDesign")
        {
            // デザインの回転
            this.rotateDesign(parameter.delta);
        }
        else if(command == "addGradationOfPattern")
        {
            // 図形のグラデーション追加
            this.addGradationOfPattern(parameter.layer, parameter.position, parameter.color);
        }
        else if(command == "removeGradationOfPattern")
        {
            // 図形のグラデーション削除
            this.removeGradationOfPattern(parameter.layer, parameter.index);
        }
        else if(command == "selectGradationOfPattern")
        {
            // グラデーションの選択変更
            this.selectGradationOfPattern(parameter.layer, parameter.index);
        }
        else if(command == "changeGradationColorOfPattern")
        {
            // グラデーションの色変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeGradationColorOfPattern(parameter.layer, parameter.index, parameter.color, isFinish);
        }
        else if(command == "changeGradationPositionOfPattern")
        {
            // グラデーションの位置変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeGradationPositionOfPattern(parameter.layer, parameter.index, parameter.position, isFinish);
        }
        else if(command == "initUndoRedo")
        {
            // アンドゥリドゥのクリア
            this.initUndoRedo();
        }
        else if(command == "changeInputMode")
        {
            // インプットモード変更
            this.changeInputMode(parameter.mode);
        }
        else if(command == "selectDesign")
        {
            // 他のデザイン選択
            this.selectDesign(parameter.position);
        }
        else if(command == "goPage")
        {
            // 他のページ切り替え
            this.goPage(parameter.page);
        }
        else if(command == "saveDocument")
        {
            // ドキュメントの保存
            this.saveDocument();
        }
        else if(command == "deleteSelectedLayer")
        {
            // 選択レイヤーの削除
            this.deleteSelectedLayer();
        }
        else if(command == "copySelectedLayer")
        {
            // 選択レイヤーのコピー
            this.copySelectedLayer(true, true);
        }
        else if(command == "pasteLayer")
        {
            // レイヤーのペースト
            this.pasteLayer();
        }
        else if(command == "groupSelectedLayer")
        {
            // 選択レイヤーのグループ化
            this.groupSelectedLayer();
        }
        else if(command == "ungroupSelectedLayer")
        {
            // 選択レイヤーのグループ化解除
            this.ungroupSelectedLayer();
        }
        else if(command == "orderLayer")
        {
            // レイヤーの順序変更
            this.orderLayer(parameter.direction);
        }
        else if(command == "bringToFrontLayer")
        {
            // レイヤーを最背面に
            this.bringToFrontCurrentLayer();
        }
        else if(command == "sendToBackLayer")
        {
            // レイヤーを最背面に
            this.sendToBackCurrentLayer();
        }
        else if(command == "changeTableCellInfo")
        {
            // 表レイヤーのセル情報変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? true : parameter.isOnce;
            this.changeTableCellInfo(parameter.layer, parameter.propertyName, parameter.value, isFinish, isOnce);
        }
        else if(command == "changeAllTableCellInfo")
        {
            // 表レイヤーのすべてのセル情報変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeAllTableCellInfo(parameter.layer, parameter.propertyName, parameter.value, isFinish);
        }
        else if(command == "changeTableCellHeight")
        {
            // 表のセルの高さ変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeTableCellHeight(parameter.layer, parameter.value, isFinish)
        }
        else if(command == "changeTableCellWidth")
        {
            // 表のセルの幅変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeTableCellWidth(parameter.layer, parameter.value, isFinish)
        }
        else if(command == "addTableCell")
        {
            // 表のセル追加
            this.addTableCell(parameter.layer, parameter.direction);
        }
        else if(command == "deleteTableCell")
        {
            // 表のセル削除
            this.deleteTableCell(parameter.layer, parameter.isDeleteRow, parameter.isDeleteColumn);
        }
        else if(command == "applyCellColor")
        {
            // セルの色適用
            this.applyCellColor(parameter.layer, parameter.isRow, parameter.isColumn);
        }
        else if(command == "createNumberLayer")
        {
            // 連番レイヤー作成
            this.createNumberLayer(parameter.parent, parameter.layerName, parameter.x, parameter.y, parameter.width, parameter.height);
        }
        else if(command == "moveMultipleLayers")
        {
            // 複数レイヤーの移動
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.moveMultipleLayers(parameter.layers, parameter.deltaX, parameter.deltaY, isFinish);
        }
        else if(command == "changeMultipleLayersProperty")
        {
            // 複数レイヤーのプロパティ変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeMultipleLayersProperty(parameter.layers, parameter.propertyName, parameter.value, isFinish);
        }
        else if(command == "alignLayerHorizontal")
        {
            // レイヤーを水平方向に整列する
            this.alignLayerHorizontal(parameter.layer, parameter.alignment);
        }
        else if(command == "alignLayerVertical")
        {
            // レイヤーを垂直方向に整列する
            this.alignLayerVertical(parameter.layer, parameter.alignment);
        }
        else if(command == "alignMultiLayersHorizontal")
        {
            // 複数レイヤーを水平方向に整列する
            this.alignMultiLayersHorizontal(parameter.layers, parameter.alignment);
        }
        else if(command == "alignMultiLayersVertical")
        {
            // 複数レイヤーを垂直方向に整列する
            this.alignMultiLayersVertical(parameter.layers, parameter.alignment);
        }
        else if(command == "trimLayer")
		{
            // レイヤーのトリミング
			this.trimLayer(parameter.layer, parameter.x, parameter.y, parameter.width, parameter.height,
				parameter.isFinish);
        }
        else if(command == "changeLayerClipShape")
        {
            // レイヤーのクリップ形状変更
            this.changeLayerClipShape(parameter.layer, parameter.pattern, parameter.corner);
        }
        else if(command == "exportDesign")
        {
            // デザインの書き出し
            this.exportDesign(parameter.quality, parameter.isClipLayer, parameter.fileType);
        }
        else if(command == "replaceTemplate")
        {
            // テンプレートの差し替え
            this.replaceTemplate();
        }
        else if(command == "importImage")
        {
            // イメージの読み込み
            this.importImage(parameter.image, parameter.imageWhiteTransparent, parameter.width, parameter.height, parameter.isSvg);
        }
        else if(command == "replaceImage")
        {
            // 画像の差し替え
            this.replaceImage(parameter.layer, parameter.image, parameter.imageWhiteTransparent, parameter.width, parameter.height, parameter.isSvg);
        }
        else if(command == "insertProfile")
        {
            // プロフィール挿入
            this.insertProfile(parameter.data);
        }
        else if(command == "fixText")
        {
            // テキストを確定する
            this.fixText();
        }
        else if(command == "enableShortcut")
        {
            // ショートカットを有効・無効化する
            this.enableShortcut(parameter.isEnable);
        }
        else if(command == "undo")
        {
            this.undo();
        }
        else if(command == "redo")
        {
            this.redo();
        }
    }

    // アンドゥ
    private undo(doCommand = true)
    {
        let result = false;
        if(this.isInTextEdit())
        {
            let canvas = this.$refs.canvasWindow as CanvasWindow;
            if(canvas != null)
            {
                if(canvas.canUndoText())
                {
                    result = true;
                    if(doCommand) canvas.undoText();
                }
            }
        }
        else
        {
            if(this.currentDesign.undoRedoManager.canUndo)
            {
                result = true;
                if(doCommand) this.currentDesign.undoRedoManager.undo();
            }
        }
        return result;
    }

    // リドゥ
    private redo(doCommand = true)
    {
        let result = false;
        if(this.isInTextEdit())
        {
            var canvas = this.$refs.canvasWindow as CanvasWindow;
            if(canvas != null)
            {
                if(canvas.canRedoText())
                {
                    result = true;
                    if(doCommand) canvas.redoText();
                } 
            }
        }
        else
        {
            if(this.currentDesign.undoRedoManager.canRedo)
            {
                result = true;
                if(doCommand) this.currentDesign.undoRedoManager.redo();
            }
        }
        return result;
    }

	// 新規レイヤー
	private newLayer(newLayer : Layer, parent : GroupLayer)
	{
        var command : NewLayerCommand = new NewLayerCommand(newLayer, parent, this.currentDesign, () => {});
        this.currentDesign.undoRedoManager.do(command);

        // カレントレイヤーが変わる場合は変形モードリセット
        this.changeEditMode(0);
    }

    // 選択したレイヤーを含んだ新しいグループを作る
    private newGroupLayerWithSelection()
    {
        const group = GroupLayer.create();
        group.name = NameHelper.createLayerName('group', this.currentDesign);
        // グループを含んでいると無限ループになるのでルートに作る
        this.currentDesign.undoRedoManager.doAsMultiCommand(
            new AddLayerCommand(group, this.currentDesign.layer)
        );
        // 選択したレイヤーをグループに移動する
        this.moveLayerPosition(this.currentDesign.selectLayers, group, 'inside');

        group.isExpanded = true;
        this.currentDesign.currentLayer = group;

        // カレントレイヤーが変わる場合は変形モードリセット
        this.changeEditMode(0);
    }

    // 新規テキストレイヤー
    private newTextLayer(newLayer : Layer, parent : GroupLayer)
    {
        // 文字列が入るボックスの縦横比
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        var text = "";
        if(newLayer instanceof TextLayer)
        {
            text = newLayer.text != "" ? newLayer.text : TextLayer.PLACEHOLDER;
        }
        else if(newLayer instanceof DateTextLayer)
        {
            text = newLayer.getText();
        }
        var size = canvasWindow.calcTextSize(text, 64, false, false, false);
        var scale = size.height / size.width;

        // テキストレイヤーの高さ調整
        if(newLayer instanceof D3TextLayer)
        {
            // 3Dテキストレイヤー
            newLayer.height = newLayer.width * scale;
            newLayer.y = (this.currentDesign.height - newLayer.height) / 2;
        }
        else if(newLayer instanceof PlainTextLayer || newLayer instanceof DateTextLayer || newLayer instanceof SimpleTextLayer)
        {
            // 通常文字レイヤー or 日付文字レイヤー or シンプルテキストレイヤー
            newLayer.height = newLayer.width * scale;
            newLayer.y = (this.currentDesign.height - newLayer.height) / 2;
        }

        var command : NewLayerCommand = new NewLayerCommand(newLayer, parent, this.currentDesign, () => {});
        this.currentDesign.undoRedoManager.do(command);

        // カレントレイヤーが変わる場合は変形モードリセット
        this.changeEditMode(0);

        // 新規テキストレイヤー作成時はすぐにテキスト編集開始
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        canvasWindow.forceStartEditText();
    }

	// レイヤー変形
	private transformLayer(layer : Layer, x : number, y : number, width : number, height : number, rotate : number, isFinish : boolean)
	{
        // ロックされてると無効
        if(layer.isLocked) { return; }

		var command : TransformLayerCommand = new TransformLayerCommand(layer, x, y, width, height, rotate, this.currentDesign, () => {});
		this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // レイヤー移動
    private moveLayer(layer : Layer, x : number, y : number, isFinish : boolean)
    {
        // ロックされてると無効
        if(layer.isLocked) { return; }

        var command : TransformLayerCommand = new TransformLayerCommand(layer, x, y, layer.width, layer.height, layer.rotate, this.currentDesign, () => {});
		this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // レイヤーリサイズ
    private resizeLayer(layer : Layer, width : number, height : number, isFinish : boolean)
    {
        // ロックされてると無効
        if(layer.isLocked) { return; }

        var command : TransformLayerCommand = new TransformLayerCommand(layer, layer.x, layer.y, width, height, layer.rotate, this.currentDesign, () => {});
		this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // レイヤー回転
    private rotateLayer(layer : Layer, rotate : number, isFinish : boolean)
    {
        // ロックされてると無効
        if(layer.isLocked) { return; }

        // 中心位置を保持
        var centerX = layer.centerX;
        var centerY = layer.centerY;

        // 前の回転角度と座標を保持
        var oldX = layer.x;
        var oldY = layer.y;
        var oldRotate = layer.rotate;

        // レイヤーを回転する
        layer.rotate = rotate;

        // 中心位置が回転前と同じになるような新しい移動先
        var dstX = layer.x - layer.centerX + centerX;
        var dstY = layer.y - layer.centerY + centerY;

        // レイヤー回転を元に戻す
        layer.rotate = oldRotate;
        layer.x = oldX;
        layer.y = oldY;

        var command : TransformLayerCommand = new TransformLayerCommand(layer, dstX, dstY, layer.width, layer.height, rotate, this.currentDesign, () => {});
		this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // 面へレイヤー複製
    private duplicateLayerToSurface(layer : Layer, isReverse : boolean)
    {
        // コマンド
        var command = new DuplicateLayerToSurfaceCommand(layer, this.currentPage, isReverse, this.currentDocument.isReverseSurface, this.currentPage.currentDesignPosition, this.currentDesign, () => {});

        if(isReverse != this.currentDocument.isReverseSurface)
        {
            // 逆面へのコピー
            // 逆面が存在しているか？
            var isExistSurface = this.currentPage.getSurface(isReverse).getDesign(this.currentPage.currentDesignPosition) != null;
            if(!isExistSurface)
            {
                // 面が存在していないので新規作成
                var newDesignCommand = new NewDesignCommand(this.currentPage.currentDesignPosition, this.currentPage, isReverse, this.currentDocument, () => {});
                this.currentDocument.undoRedoManager.do(newDesignCommand);
            }
            // 逆面のアンドゥ・リドゥに対してコマンドを記録する
            var reverseDesign = this.currentPage.getSurface(isReverse).getDesign(this.currentPage.currentDesignPosition);
            if(reverseDesign != null)
            {
                reverseDesign.undoRedoManager.do(command);
            }
        }
        else
        {
            // カレントデザインにコマンドを記録する
            this.currentDesign.undoRedoManager.do(command);
        }
    }

    // 複数のレイヤーを複製する
    private duplicateLayers()
    {
        const layers = this.currentDesign.selectLayers;
        layers.forEach((layer) => {
            this.duplicateLayerToSurface(layer, this.isReverseSurface);
        });
    }

    // レイヤー削除
    private deleteLayer(deleteLayer : Layer)
    {
        // ロックしている場合は削除しない
        if(deleteLayer.isLocked) { return; }

        // ターゲットレイヤーの親を得る。
        var parent = this.currentDesign.getParentLayer(deleteLayer);
        if(parent != null)
        {
            // 親レイヤーから削除する。
            var command = new DeleteLayerCommand(deleteLayer, parent, this.currentDesign, () => {});
            this.currentDesign.undoRedoManager.do(command);
        }
    }

	// カレントレイヤー変更
	private changeCurrentLayer(layer : Layer | null)
	{
		// アンドゥリドゥには残さない
		this.currentDesign.currentLayer = layer;
    }

    private appendLayerSelection(layer: Layer)
    {
        this.currentDesign.addSelectLayer(layer);
    }

    private removeLayerSelection(layer: Layer)
    {
        this.currentDesign.removeSelectLayer(layer);
    }

    // 選択レイヤー変更
    private selectLayer(layer : Layer, isSelect : boolean)
    {
        // アンドゥリドゥには残さない
        if(isSelect)
        {
            for(var selectLayer of this.currentDesign.selectLayers)
            {
                if(layer == selectLayer) { return; }
            }
            this.currentDesign.addSelectLayer(layer);
        }
        else
        {
            var isExisted = false;
            for(var selectLayer of this.currentDesign.selectLayers)
            {
                if(layer == selectLayer)
                {
                    isExisted = true;
                    break;
                }
            }
            if(isExisted)
            {
                this.currentDesign.removeSelectLayer(layer);
            }
        }
    }

    // 選択レイヤー一斉変更
    private changeSelectLayers(layers : Array<Layer>)
    {
        // テキスト編集確定
        if(this.isInTextEdit()) this.fixText();
        // アンドゥリドゥには残さない
        this.currentDesign.clearSelectLayers();
        for(var layer of layers)
        {
            this.currentDesign.addSelectLayer(layer);
        }
    }

    // レイヤープロパティ変更
    private changeLayerProperty(layer : Layer, propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangeLayerPropertyCommand(layer, propertyName, value, () => {});

        // 縦横比固定処理
        if(propertyName == "keepRatio" && value == 0 &&
            (layer.layerType == "rasterImage" || layer.layerType == "vectorImage" || layer.layerType == "rectangle" || layer.layerType == "circle" || layer.layerType == "polygon" ||
            layer.layerType == "specialPattern"))
        {
            // シングルコマンドの場合もマルチコマンドでリサイズを入れる必要がある。
            if(isOnce)
            {
                isOnce = false;
                isFinish = true;
            }

            // レイヤーに対して新しい幅・高さを得る
            var newWidth = layer.width;
            var newHeight = layer.height;
            if(layer instanceof ImageLayer)
            {
                // まず高さを変える
                newHeight = layer.width * layer.imageHeight / layer.imageWidth;
                if(newHeight > Math.min(layer.width, layer.height))
                {
                    // レイヤーの短辺を超える場合は幅の方を変える
                    newHeight = layer.height;
                    newWidth = layer.height * layer.imageWidth / layer.imageHeight;
                }
            }
            else if(layer instanceof PolygonLayer)
            {
                // 短辺合わせ
                var shorter = Math.min(layer.width, layer.height);
                var points = PathHelper.createPolygonControlPoints(layer.cornerNumber, 0, 0, shorter, shorter, true);
                var bounds = PathHelper.getBoundsFromPoints(points);
                // まず高さを変える
                newHeight = layer.width * bounds.height / bounds.width;
                if(newHeight > Math.min(layer.width, layer.height))
                {
                    // レイヤーの短辺を超える場合は幅の方を変える
                    newHeight = layer.height;
                    newWidth = layer.height * bounds.width / bounds.height;
                }
            }
            else if(layer instanceof SpecialPatternLayer)
            {
                // まず高さを変える
                newHeight = layer.width * layer.baseHeight / layer.baseWidth;
                if(newHeight > Math.min(layer.width, layer.height))
                {
                    // レイヤーの短辺を超える場合は幅の方を変える
                    newHeight = layer.height;
                    newWidth = layer.height * layer.baseWidth / layer.baseHeight;
                }
            }
            else
            {
                // 短辺合わせ
                newWidth = Math.min(layer.width, layer.height);
                newHeight = newWidth;
            }

            // 変形
            this.transformLayer(layer, layer.x, layer.y, newWidth, newHeight, layer.rotate, false);
        }

        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // 通常テキストレイヤーの文法情報全変更
    private changePlainTextLayerWholeTextInfo(layer : PlainTextLayer, propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangePlainTextLayerWholeTextInfoCommand(layer, propertyName, value, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // 通常テキストレイヤーの文法情報範囲変更
    private changePlainTextLayerRangeTextInfo(layer : PlainTextLayer, textInfoArray : Array<TextInfo>, startPosition : number, endPosition : number, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangePlainTextLayerRangeTextInfoCommand(layer, textInfoArray, startPosition, endPosition, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // シンプルテキストレイヤーの文法情報変更
    private changeSimpleTextLayerTextInfo(layer : SimpleTextLayer, propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangeSimpleTextLayerTextInfoCommand(layer, propertyName, value, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // 曲線レイヤーの制御点変更
    private moveCurveControlPoint(layer : CurveLayer, index : number, x : number, y : number, isFinish : boolean)
    {
        var command = new MoveCurveControlPointCommand(layer, index, x, y, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // 多角形レイヤーの制御点変更
    private movePolygonControlPoint(layer : PolygonLayer, index : number, x : number, y : number, isFinish : boolean)
    {
        var command = new MovePolygonControlPointCommand(layer, index, x, y, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // 多角形レイヤーの制御点適用
    private applyPolygonControlPoints(layer : PolygonLayer, points : Array<Vector2>, isFinish : boolean, isOnce : boolean)
    {
        var command = new ApplyPolygonControlPointsCommand(layer, points, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // レイアウトへ遷移
    private toLayout()
    {
        // 画像を更新
        // 処理中表示する
        this.isWaiting = true;
        this.updateCanvasImage(() =>
        {
            // 完了したら画面遷移
            this.goLink("/LayoutEditor", true);
        });
    }

    // 差し込みに遷移
    private toInsertion()
    {
        // 画像を更新
        this.updateCanvasImage(() =>
        {
            // 完了したら画面遷移
            this.goLink("/InsertionEditor", false);
        });
    }

    // デザインの保持するキャンバス画像を更新する
    // デザインの書き出し
    private updateCanvasImage(completion : () => void)
    {
        // サムネイル作成廃止
        completion();
    //     // SVGもPNGもない 変更されている or 前回保存時と回転角が変更されている 場合は更新するべき
    //     var isNeededUpdate = (this.currentDesign.thumbnailSvg == "" && this.currentDesign.thumbnailImageBase64 == "") ||
    //         this.currentDesign.isModified() ||
    //         this.currentDesign.thumbnailSvgRotate != this.currentDesign.rotate + this.currentDocument.rotate;
    //     if(!isNeededUpdate)
    //     {
    //         // 更新しなくていい場合は完了処理

    //         // ハッシュをアップデート
    //         this.currentDesign.updateHash();

    //         completion();
    //         return;
    //     }

    //     // レンダリング開始
    //     var quality = 3;
    //     var isClipLayer = false;
    //     var isRenderingThumbnail = true;
    //     this.startRendering(quality, isClipLayer, isRenderingThumbnail);
    //     this.$nextTick(() =>
    //     {
    //         var renderer = this.$refs.designrenderer;
    //         if(renderer != null && renderer instanceof DesignRenderer)
    //         {
    //             const done = (img) => {
    //                 this.currentDesign.thumbnailImageBase64 = img;

    //                 // ハッシュをアップデート
    //                 this.currentDesign.updateHash();

    //                 completion();
    //             };

    //             const rotateIfNeeded = (img) => {
    //                 // デザインの回転とドキュメントの回転の合計
    //                 const deltaRotate = this.currentDesign.rotate + this.currentDocument.rotate;
    //                 if(deltaRotate % 360 == 0) {
    //                     done(img);
    //                 } else {
    //                     // デザイン, 用紙の回転を元に戻す
    //                     ImageHelper.rotateImage(img, -deltaRotate, done);
    //                 }
    //             };

    //             // if (UserAgentHelper.isElectron()) {
    //             //     // Electronにサムネイルの生成を任せる
	//             //     const xml = (new XMLSerializer()).serializeToString(renderer.getSvgElement());
	//             //     const blob = new Blob([xml], {type: 'image/svg+xml'});
    //             //     const url = `${URL.createObjectURL(blob)}?op=thumbnail&width=${renderer.viewWidth}&height=${renderer.viewHeight}`;
    //             //     window.open(url);

	//             //     // サムネイルを受け取るためのイベントを登録する
	//             //     const mc = this.$store.getters.messageCenter;
	//             //     mc.subscribe(this, "set-thumbnail", ({ thumbnail }) => {
	//             //         rotateIfNeeded(thumbnail);
	//             //         mc.unsubscribe(this, "set-thumbnail"); // 実行したらイベント消去
	//             //     });
    //             // } else {
    //                 const params = renderer.getSvgImage();

    //                 // イメージのレンダリングをするためのsvg情報を保持する
    //                 this.currentDesign.thumbnailSvg = params.image;
    //                 this.currentDesign.thumbnailImageWidth = params.width;
    //                 this.currentDesign.thumbnailImageHeight = params.height;
    //                 this.currentDesign.thumbnailSvgRotate = this.currentDesign.rotate + this.currentDocument.rotate;

    //                 // サムネイルは空にする
    //                 done("");
    //             // }
    //         }
    //         // レンダリング終了
    //         this.endRendering();
    //     });
    }

    // 面変更
    private changeSurface(isReverse : boolean)
    {
        // 面を返す前に、逆の面が存在しているかチェック
        var page = this.currentDocument.pageList[this.currentDocument.currentPageIndex];
        var isExistSurface = page.getSurface(isReverse).getDesign(page.currentDesignPosition) != null;
        // 面が存在していない場合は新規作成
        if(!isExistSurface)
        {
            var command = new NewDesignCommand(page.currentDesignPosition, page, isReverse, this.currentDocument, () => {});
            this.currentDocument.undoRedoManager.do(command);
        }

        // サムネイルを更新して面を切り替える
        this.updateCanvasImage(()=>
        {
            this.currentDocument.setSurface(isReverse);
        });
    }

    // テキスト変更
    private changeText(layer : TextLayer, text : string, isFinish : boolean)
    {
        if(isFinish && this.currentDesign.undoRedoManager.multiCommandCount == 0)
        {
            // テキスト変更完了は、multiCommandの数 == 0 のときはテキスト変更がされていないと判定して、行わない。
            return;
        }
        var command = new ChangeTextCommand(layer, text, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // マルチコマンド終了
    private fixMultiCommand()
    {
        this.currentDesign.undoRedoManager.fixMultiCommand();
    }

    // ズーム倍率変更
    private changeZoomScale(scale, isAutoZoomOff)
    {
        this.zoomScale = scale;

        // オートズーム解除
        if(isAutoZoomOff && this.isAutoZoom) { this.isAutoZoom = false; }
    }

    // ズーム倍率のステップ変更
    private changeZoomScaleByStep(up : boolean, isAutoZoomOff : boolean, doCommand : boolean = true) : boolean
    {
        var result = false;
        if(up)
        {
            // 最大ズームサイズチェック
            if(this.zoomScale < Const.CANVAS_ZOOM_MAX)
            {
                if(doCommand)
                {
                    // ズームサイズを+25
                    var newZoomScale = this.zoomScale + 25;
                    if(newZoomScale > Const.CANVAS_ZOOM_MAX) { newZoomScale = Const.CANVAS_ZOOM_MAX; }
                    this.zoomScale = newZoomScale;

                    // オートズーム解除
                    if(isAutoZoomOff && this.isAutoZoom) { this.isAutoZoom = false; }
                }
                result = true;
            }
        }
        else
        {
            // 最小ズームサイズチェック
            if(this.zoomScale > Const.CANVAS_ZOOM_MIN)
            {
                if(doCommand)
                {
                    // ズームサイズを-25
                    var newZoomScale = this.zoomScale - 25;
                    if(newZoomScale < Const.CANVAS_ZOOM_MIN) { newZoomScale = Const.CANVAS_ZOOM_MIN; }
                    this.zoomScale = newZoomScale;

                    // オートズーム解除
                    if(isAutoZoomOff && this.isAutoZoom) { this.isAutoZoom = false; }
                }
                result = true;
            }
        }

        return result;
    }

    // 自動ズーム切り替え
    private changeAutoZoom(isAutoZoom)
    {
        this.isAutoZoom = isAutoZoom;
    }

    // レイヤーの位置を変える
    private moveLayerPosition(layersTemp: Array<Layer>, toLayer: Layer, placement: 'inside' | 'before' | 'after')
    {
        if (placement === 'inside' && !(toLayer instanceof GroupLayer)) { return; }

        // レイヤーの並び替え
        var layers : Array<Layer> = [];
        var allLayers = this.currentDesign.getAllLayers(true);
        for(var i = 0; i < allLayers.length; ++i)
        {
            var temp = allLayers[i];
            for(var j = 0; j < layersTemp.length; ++j)
            if(temp == layersTemp[j])
            {
                layers.push(temp);
            }
        }

        for(var i = 0; i < layers.length; ++i)
        {
            var layer : Layer = layers[i];
            // 一旦ツリーから外す
            const parent = this.currentDesign.getParentLayer(layer) as GroupLayer;
            if (parent) {
                this.currentDesign.undoRedoManager.doAsMultiCommand(
                    new DeleteLayerCommand(layer, parent, this.currentDesign, () => {})
                );
            }

            // 改めて追加する
            if (placement === 'inside') {
                this.currentDesign.undoRedoManager.doAsMultiCommand(
                    new NewLayerCommand(layer, <GroupLayer>toLayer, this.currentDesign, () => {})
                );
            }
            else {
                const toParent = this.currentDesign.getParentLayer(toLayer) as GroupLayer;
                if (toParent) {
                    const i = toParent.getLayerIndex(toLayer);
                    const insertIndex = (placement === 'before') ? i + 1 : i;
                    this.currentDesign.undoRedoManager.doAsMultiCommand(
                        new InsertLayerCommand(layer, toParent, insertIndex, this.currentDesign, () => {})
                    );
                }
            }
        };
        this.currentDesign.undoRedoManager.fixMultiCommand();
    }

    // コンテキストメニュー表示
    private showContextMenu(event, type : string)
    {
        DebugHelper.trace(event);
        DebugHelper.trace(type);
        var contextMenu = this.$refs.menu as ContextMenu;
        if(contextMenu != null)
        {
            // menuItems
            var menuItems = new Array();
            if(type == "objectlist")
            {
                // オブジェクトリスト
                var currentLayer = this.currentDesign.currentLayer;
                menuItems.push({ text : "コピー", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("duplicateLayer") } });
                menuItems.push({ text : "削除", isEnable : currentLayer != null && !currentLayer.isLocked,  callback : () => { this.onSelectContextMenu("deleteLayer")} });
                menuItems.push({ text : "ロック/ロック解除", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("lockLayer") } });
                menuItems.push({ text : "グループ化/グループ化解除", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("toggleGroupLayer") } });
                menuItems.push({ text : "最前面へ", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("layerToFront") } });
                menuItems.push({ text : "前面へ", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("layerUp") } });
                menuItems.push({ text : "背面へ", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("layerDown") } });
                menuItems.push({ text : "最背面へ", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("layerToBack") } });
                menuItems.push({ text : "名前変更", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("renameLayer") } });
                if(currentLayer != null && currentLayer instanceof GroupLayer)
                {
                    // グループレイヤーのみ
                    menuItems.push({ text : "開く/閉じる", isEnable : currentLayer != null && currentLayer instanceof GroupLayer,  callback : () => { this.onSelectContextMenu("expandLayer") } });
                }
            }
            else if(type == "layer")
            {
                // レイヤー
                var currentLayer = this.currentDesign.currentLayer;
                menuItems.push({ text : "切り取り", isEnable : this.cutSelectedLayer(false),  callback : () => { this.cutSelectedLayer(true, true); } });
                menuItems.push({ text : "コピー", isEnable : this.copySelectedLayer(false),  callback : () => { this.copySelectedLayer(true, true); } });
                if(UserAgentHelper.isElectron() || UserAgentHelper.getBrowser() == "chrome")
                {
                    // クリップボード貼り付け
                    menuItems.push({ text : "貼り付け", isEnable : true, callback : () => { this.onSelectContextMenu("pasteClipboard"); } });
                }
                else
                {
                    // レイヤー貼り付け
                    menuItems.push({ text : "貼り付け", isEnable : this.pasteLayer(false),  callback : () => { this.pasteLayer(true); } });
                }
                menuItems.push({ text : "削除", isEnable : this.deleteSelectedLayer(false),  callback : () => { this.deleteSelectedLayer(true); } });
                menuItems.push({ text : "選択の解除", isEnable : this.unselectAllLayers(false), callback : () => { this.unselectAllLayers(true); } });
                menuItems.push({ text : "全てを選択", isEnable : this.selectAllLayers(false),  callback : () => { this.selectAllLayers(true); } });
            }
            else if(type == "text")
            {
                // テキスト
                menuItems.push({ text : "切り取り", isEnable : this.canCutText(), callback : () => { this.cutText(); } });
                menuItems.push({ text : "コピー", isEnable : this.canCopyText(),  callback : () => { this.copyText(); } });
                menuItems.push({ text : "貼り付け", isEnable : true,  callback : () => { this.pasteText(); } });
                menuItems.push({ text : "削除", isEnable : this.canDeleteText(),  callback : () => { this.deleteText(); } });
                menuItems.push({ text : "選択の解除", isEnable : this.canDeselectText(), callback : () => { this.deselectText(); } });
                menuItems.push({ text : "全てを選択", isEnable : true,  callback : () => { this.selectAllText(); } });
            }
            contextMenu.open(event, menuItems);
        }
    }

    private hideContextMenu()
    {
        let contextMenu = this.$refs.menu as ContextMenu;
        contextMenu.close();
    }

    canCutText()
    {
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        return canvasWindow.isTextSelected();
    }

    cutText()
    {
        this.copyText();
        setTimeout(() =>
        {
            this.deleteText();
        }, 10);
    }

    canCopyText()
    {
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        return canvasWindow.isTextSelected();
    }

    copyText()
    {
        document.execCommand("copy");
    }

    pasteText()
    {
        if(navigator.clipboard && navigator.clipboard.readText)
        {
            // IE以外
            navigator.clipboard.readText().then(text =>
            {
                if(text != null)
                {
                    var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
                    canvasWindow.pasteText(text);
                }
            }).catch(e => 
            {
                DebugHelper.trace("paste text error:");
                DebugHelper.trace(e);
            });
        }
        else if((window as any).clipboardData)
        {
            // IE
            let text = (window as any).clipboardData.getData("Text");
            if(text != null)
            {
                var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
                canvasWindow.pasteText(text);
            }
        }
    }

    canDeleteText()
    {
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        return canvasWindow.isTextSelected();
    }

    deleteText()
    {
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        canvasWindow.deleteText();
    }

    selectAllText()
    {
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        canvasWindow.selectAllText();
    }

    canDeselectText()
    {
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        return canvasWindow.isTextSelected();
    }

    deselectText()
    {
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        canvasWindow.deselectText();
    }

    // コンテキストメニュー処理
    private onSelectContextMenu(menu)
    {
        var currentLayer = this.currentDesign.currentLayer;
        if(menu == "duplicateLayer")
        {
            this.duplicateLayers();
        }
        else if(menu == "deleteLayer")
        {
            this.deleteSelectedLayer();
        }
        else if(menu == "lockLayer")
        {
            // レイヤーロック
            if(currentLayer != null)
            {
                var isLocked = currentLayer.isLocked;
                var lockCommand = new ChangeLayerPropertyCommand(currentLayer, "isLocked", !isLocked, () => {} );
                this.currentDesign.undoRedoManager.do(lockCommand);
            }
        }
        else if(menu == "toggleGroupLayer")
        {
            // レイヤーのグループ化・グループ解除
            this.switchGroupLayer();
        }
        else if(menu == "layerToFront")
        {
            // レイヤーを最前面へ
            if(currentLayer != null)
            {
                var parent = this.currentDesign.getParentLayer(currentLayer);
                var top = this.currentDesign.layer;
                if(parent != null && top != null && top instanceof GroupLayer)
                {
                    // レイヤーをいったん削除する
                    var deleteCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {} );
                    this.currentDesign.undoRedoManager.doAsMultiCommand(deleteCommand, false);
                    // レイヤーを最前面に追加する
                    var newLayerCommand = new NewLayerCommand(currentLayer, top, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(newLayerCommand, true);
                }
            }
        }
        else if(menu == "layerToBack")
        {
            // レイヤーを最背面へ
            if(currentLayer != null)
            {
                var parent = this.currentDesign.getParentLayer(currentLayer);
                var top = this.currentDesign.layer;
                if(parent != null && top != null && top instanceof GroupLayer)
                {
                    // レイヤーをいったん削除する
                    var deleteCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {} );
                    this.currentDesign.undoRedoManager.doAsMultiCommand(deleteCommand, false);
                    // レイヤーを最背面に追加する
                    var insertLayerCommand = new InsertLayerCommand(currentLayer, top, 0, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(insertLayerCommand, true);
                }
            }
        }
        else if(menu == "layerUp")
        {
            // レイヤーを前面へ
            this.orderLayer("up");
        }
        else if(menu == "layerDown")
        {
            // レイヤーを背面へ
            this.orderLayer("down");
        }
        else if(menu == "renameLayer")
        {
            // レイヤーの名前変更
            if(currentLayer != null)
            {
                this.renameId = currentLayer.id;
                this.$nextTick(() =>
                {
                    this.renameId = "";
                });
            }
        }
        else if(menu == "expandLayer")
        {
            // レイヤーの開閉
            if(currentLayer != null && currentLayer instanceof GroupLayer)
            {
                var isExpanded = currentLayer.isExpanded;
                var expandCommand = new ChangeLayerPropertyCommand(currentLayer, "isExpanded", !isExpanded, () => {} );
                this.currentDesign.undoRedoManager.do(expandCommand);
            }
        }
        else if(menu == "pasteClipboard")
        {
            if(UserAgentHelper.isElectron())
            {
                // DL版はイベントを通知して呼び出してもらう
                NativeHelper.sendNativeEvent("request_paste", {});
            }
            else
            {
                try
                {
                    // クリップボードから貼り付け
                    // localhost or httpsでのみ使用できます。
                    navigator.clipboard['read']().then(items =>
                    {
                        let imageItems : any[] = [];
                        let imageTypes : any[] = [];
                        for(var item of items)
                        {
                            for(var type of item.types)
                            {
                                if(type.indexOf('image') >= 0)
                                {
                                    imageItems.push(item);
                                    imageTypes.push(type);
                                }
                            }
                        }
                        if(imageItems.length > 0)
                        {
                            let process = (index : number, items : any[] , types : any[], completion : () => void, reject : () => void) => {
                                if(index >= items.length || index >= types.length) {
                                    reject();
                                    return;
                                }
                                let imageItem = items[index];
                                let imageType = types[index];
                                imageItem.getType(imageType).then(blob =>
                                {
                                    try
                                    {
                                        // Blob -> base64
                                        var reader = new FileReader();
                                        reader.onload = () =>
                                        {
                                            var imageBase64 = reader.result;
                                            // クリップボードに登録
                                            this.$store.getters.clipboardManager.setImageData(imageBase64, this.currentDesign, () =>
                                            {
                                                // クリップボードが更新された状態で貼り付けを実行する
                                                this.pasteLayer();
                                            });
                                        };
                                        reader.readAsDataURL(blob);
                                        completion();
                                    }
                                    catch(ex)
                                    {
                                        DebugHelper.trace(ex);
                                        // 次の処理
                                        process(index + 1, imageItems, imageTypes, completion, reject);
                                    }
                                });
                            }

                            process(0, imageItems, imageTypes, () => {
                                DebugHelper.trace("[command]image data in clipboard is pasted.");
                            }, () => {
                                // データがないのでレイヤーのペーストを行う
                                DebugHelper.trace("[command]no image data in clipboard. -> paste layer.");
                                this.pasteLayer();
                            });
                        }
                    }).catch(e => {
                        DebugHelper.trace("reading clipboard is failed -> paste layer:")
                        DebugHelper.trace(e);
                        this.pasteLayer();
                    });
                }
                catch(e)
                {
                    DebugHelper.trace("reading clipboard error -> paste layer:")
                    DebugHelper.trace(e);
                    this.pasteLayer();
                }
            }
        }
    }

    // 名前の編集が開始された
    private onEditLayerName() {
        // Deleteキーが使えないのでショートカットを一旦OFFにする
        document.removeEventListener("keydown", this.onKeyDown)
    }

    // 名前が変更された
    private onDecideLayerName() {
        // ショートカットを戻す
        document.addEventListener("keydown", this.onKeyDown)
    }

    // 曲線編集モード変更
    private changeCurveEditMode(mode : number)
    {
        this.$store.getters.applicationState.curveEditMode = mode;
    }

    // 編集モード変更
    private changeEditMode(mode : number)
    {
        this.$store.getters.applicationState.editMode = mode;
    }

    // 曲線に制御点追加
    private addControlPointToCurve(layer : CurveLayer, index : number, x : number, y : number)
    {
        var command = new AddControlPointToCurveCommand(layer, index, x, y, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // 曲線の制御点削除
    private removeControlPointFromCurve(layer : CurveLayer, index : number)
    {
        var command = new RemoveControlPointFromCurveCommand(layer, index, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // デザインを指定角度回転
    private rotateDesign(delta : number)
    {
        var command = new RotateDesignCommand(this.currentDesign, delta, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // 図形のグラデーションを追加
    private addGradationOfPattern(layer : PatternBaseLayer, position : number, color : ColorConstruct)
    {
        var command = new AddGradationOfPatternCommand(layer, position, color, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // 図形のグラデーションを削除
    private removeGradationOfPattern(layer : PatternBaseLayer, index : number)
    {
        var command = new RemoveGradationOfPatternCommand(layer, index, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // グラデーションの選択変更
    private selectGradationOfPattern(layer : PatternBaseLayer, index : number)
    {
        // アンドゥ、リドゥの対象外
        layer.selectedGradationPoint = index;
    }

    // グラデーションの色変更
    private changeGradationColorOfPattern(layer : PatternBaseLayer, index : number, color : ColorConstruct, isFinish : boolean)
    {
        var command = new ChangeGradationColorOfPatternCommand(layer, index, color, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // グラデーションの位置変更
    private changeGradationPositionOfPattern(layer : PatternBaseLayer, index : number, position : number, isFinish : boolean)
    {
        var command = new ChangeGradationPositionOfPatternCommand(layer, index, position, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // アンドゥリドゥの初期化
    private initUndoRedo()
    {
        this.currentDesign.undoRedoManager.init();
    }

    // インプットモード変更
    private changeInputMode(mode : number)
    {
        this.$store.getters.applicationState.inputMode = mode;
    }

    // 他のデザインを選択
    private isRunning = false;
    private selectDesign(position : number)
    {
        if(this.isRunning) { return; }
        this.isRunning = true;

        // テキスト編集を確定する
        if(this.isInTextEdit()) this.fixText();

        // 差し込みの場合はデザイン切り替えなし
        var flowMode = this.$store.getters.applicationState.flowMode;
        if(flowMode == 1 || flowMode == 2 || flowMode == 3) { return; }

        // デザインが存在するか?
        var isExistDesign = this.currentPage.getSurface(this.currentDocument.isReverseSurface).getDesign(position) != null;
        if(!isExistDesign)
        {
            // デザインが存在しないので、新規作成する
            var command = new NewDesignCommand(position, this.currentPage, this.currentDocument.isReverseSurface, this.currentDocument, () => {});
            this.currentDocument.undoRedoManager.do(command);
        }
        // サムネイルを更新してデザインを切り替える
        this.updateCanvasImage(()=>
        {
            this.currentPage.currentDesignPosition = position;
            this.isRunning = false;
        });
    }

    // ページ切り替え
    private goPage(page : number)
    {
        if(this.isRunning) { return; }
        this.isRunning = true;

        // 差し込みの場合はページ切り替えなし
        var flowMode = this.$store.getters.applicationState.flowMode;
        if(flowMode == 1 || flowMode == 2)
        {
            this.isRunning = false;
            return;
        }

        // ページ切り替え処理
        var process = () =>
        {
            var newPage = this.currentDocument.pageList[page];
            // デザインが存在するか?
            var isExistDesign = newPage.getSurface(this.currentDocument.isReverseSurface).getDesign(newPage.currentDesignPosition) != null;
            if(!isExistDesign)
            {
                // デザインが存在しないので、新規作成する
                var command = new NewDesignCommand(newPage.currentDesignPosition, newPage, this.currentDocument.isReverseSurface, this.currentDocument, () => {});
                this.currentDocument.undoRedoManager.do(command);
            }
            // サムネイルを更新してページを切り替える
            this.updateCanvasImage(()=>
            {
                this.currentDocument.currentPageIndex = page;
                this.isRunning = false;
            });
        };

        // 現在のページ数
        var currentPageCount = this.currentDocument.pageList.length;
        if(0 <= page && page < currentPageCount + 1 && page < Const.MAX_PAGE_NUMBER)
        {
            if(page == currentPageCount)
            {
                // 1ページ追加するか問い合わせる
                var addPageModal = this.$refs.addPageModal as AddPage;
                addPageModal.open(() =>
                {
                    // ページ追加
                    var command = new NewPageCommand(page, this.currentDocument, () => {});
                    this.currentDocument.undoRedoManager.do(command);
                    // ページ切り替え処理
                    process();
                }, () =>
                {
                    this.isRunning = false;
                });
            }
            else
            {
                // そのままページ遷移
                process();
            }
        }
        else
        {
            // 何もしない
            this.isRunning = false;
        }
    }

    // ドキュメントの保存
    private saveDocument()
    {
        if(UserAgentHelper.isElectron())
        {
            // DL版はネイティブで保存する
            NativeHelper.sendNativeEvent("request_save_as_document", {});
            return;
        }

        var comp = () =>
        {
            // 開いた時のファイル名があればそれを使う
            var fileName = this.currentDocument.openedFileName != "" ? FileHelper.getFilenameWithoutExtension(this.currentDocument.openedFileName) : NameHelper.createNewDocumentFileName(this.currentDocument);
            FileHelper.saveDocumentAsZip(this.currentDocument, fileName);
            this.sendSaveLog();
        };

        var alert = this.$refs.saveAttentionAlert as SaveAttentionAlert;
        if(alert.isAvailable())
        {
            // モーダルを開き、OKを押したときにセーブ
            alert.open(comp);
        }
        else
        {
            comp();
        }
    }

    // 履歴送信
    private sendSaveLog()
    {
        var logValue = {
            productId : this.currentDocument.productId,
            code : this.currentDocument.paperCode,
            templateId : this.$store.getters.data.selectedTemplate.id,
            cloud : 0
        }

        LogHelper.sendLog("1000", logValue);
    }

    // 選択レイヤーの削除
    private deleteSelectedLayer(doCommand : boolean = true)
    {
        var canExecute = false;

        // 全ての選択レイヤーのうち、ロックされていないレイヤーを削除する
        var selectedLayers = this.currentDesign.selectLayers;
        for(var i = 0; i < selectedLayers.length; ++i)
        {
            var selectedLayer = selectedLayers[i];
            if(selectedLayer.isLocked) { continue; }
            var parentLayer = this.currentDesign.getParentLayer(selectedLayer);
            if(parentLayer == null) { continue; }

            canExecute = true;
            if(doCommand)
            {
                var deleteLayerCommand = new DeleteLayerCommand(selectedLayer, parentLayer, this.currentDesign, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(deleteLayerCommand, false);
            }
        }
        if(doCommand)
        {
            this.fixMultiCommand();
        }

        if(canExecute && doCommand)
        {
            // 全選択を外す
            this.currentDesign.clearSelectLayers();
        }

        return canExecute;
    }

    // 選択レイヤーの切り取り
    private cutSelectedLayer(doCommand : boolean = true, clearClipboard = false)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        var canExecute = false;

        var cutLayers = new Array();
        // 全ての選択レイヤーのうち、ロックされていないレイヤーを削除する
        var selectedLayers = this.currentDesign.selectLayers;
        for(var i = 0; i < selectedLayers.length; ++i)
        {
            var selectedLayer = selectedLayers[i];
            if(selectedLayer.isLocked) { continue; }
            var parentLayer = this.currentDesign.getParentLayer(selectedLayer);
            if(parentLayer == null) { continue; }

            canExecute = true;
            cutLayers.push(selectedLayer);
            if(doCommand)
            {
                var deleteLayerCommand = new DeleteLayerCommand(selectedLayer, parentLayer, this.currentDesign, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(deleteLayerCommand, false);
            }
        }
        this.fixMultiCommand();
        if(cutLayers.length > 0 && doCommand)
        {
            // 選択レイヤーのコピー
            this.clipboardManager.copy(cutLayers);
            if(clearClipboard)
            {
                // OSクリップボードのクリア
                this.clearOSClipboard();
            }
        }

        return canExecute;
    }

    // 選択レイヤーのコピー
    private copySelectedLayer(doCommand : boolean = true, clearClipboard = false)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        let result = this.clipboardManager.copy(this.currentDesign.selectLayers, doCommand);
        if(doCommand && result && clearClipboard)
        {
            // OSクリップボードのクリア
            this.clearOSClipboard();
        }

        return result;
    }

    clearOSClipboard()
    {
        DebugHelper.trace("Clear OS Clipboard.");
        try
        {
            // クリップボードをクリアする
            navigator.clipboard["writeText"](" ").then(() =>
            {
                DebugHelper.trace("clear clipboard success");
            }, function() {
                DebugHelper.trace("clear clipboard failed");
            });
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }
    }

    // レイヤーのペースト
    private pasteLayer(doCommand : boolean = true)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        var canExecute = false;

        var layers = this.clipboardManager.getAsLayerArray();
        if(layers != null && layers.length > 0)
        {
            canExecute = true;
            if(doCommand)
            {
                // ペースト先はカレントがあればその親、なければデザイン直下
                var parent = this.currentLayer != null ? this.currentDesign.getParentLayer(this.currentLayer) : null;
                if(parent == null) { parent = this.currentDesign.layer; }
                // 貼り付け対象となる全レイヤーについて、同じX,Y座標を持つ既存のレイヤーが存在するか調べ、あったら位置をずらす
                var allLayers = this.currentDesign.getAllLayers(false);
                var dx = 0;
                var dy = 0;

                // 永久にチャレンジすると画面外に行ってしまうので32回を限度とします。
                for(var i = 0; i < 32; ++i)
                {
                    if(this.isExistSamePositionLayer(layers, allLayers, dx, dy))
                    {
                        // 2mmずらす
                        dx += 2;
                        dy += 2;
                    }
                    else
                    {
                        break;
                    }
                }

                // すべてのレイヤーを貼り付け
                // 重なり順を一致させるために逆に貼り付ける
                for(var i = layers.length - 1; i >= 0; --i)
                {
                    var pasteLayer = layers[i];
                    // 位置をずらす
                    pasteLayer.x += dx;
                    pasteLayer.y += dy;
                    pasteLayer.insertionId = UuidHelper.getUuid();
                    var command = new NewLayerCommand(pasteLayer, parent, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(command, i == 0);
                }
            }
        }

        return canExecute;
    }

    // 同じ場所にレイヤーが存在するか調べる
    private isExistSamePositionLayer(pastLayers : Array<Layer>, allLayers : Array<Layer>, dx : number, dy : number)
    {
        var isExistSamePositionLayer = false;
        for(var i = 0; i < pastLayers.length; ++i)
        {
            var pasteLayer = pastLayers[i];
            for(var j = 0; j < allLayers.length; ++j)
            {
                var targetLayer = allLayers[j];
                if(MathHelper.equals(pasteLayer.x + dx, targetLayer.x) && MathHelper.equals(pasteLayer.y + dy, targetLayer.y))
                {
                    isExistSamePositionLayer = true;
                    break;
                }
            }
            if(isExistSamePositionLayer) { break; }
        }

        return isExistSamePositionLayer;
    }

    // 選択レイヤーのグループ化
    private groupSelectedLayer(doCommand : boolean = true)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        var canExecute = false;

        var selectedLayers = this.currentDesign.selectLayers;
        if(selectedLayers.length > 0)
        {
            canExecute = true;
            if(doCommand)
            {
                var groupLayer = GroupLayer.create();
                groupLayer.name = NameHelper.createLayerName("group", this.currentDesign);

                // 選択レイヤーをグループに追加
                // これ逆に追加しないと結果が変わる
                for(var i = selectedLayers.length - 1; i >= 0; --i)
                {
                    groupLayer.addLayer(selectedLayers[i].clone());
                }

                var parent = this.currentLayer != null ? this.currentDesign.getParentLayer(this.currentLayer) : this.currentDesign.layer;
                if(parent == null) { parent = this.currentDesign.layer; }

                if(this.currentLayer != null)
                {
                    var index = parent.getLayerIndex(this.currentLayer);
                    var insertLayerCommand = new InsertLayerCommand(groupLayer, parent, index + 1, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(insertLayerCommand, false);
                }
                else
                {
                    var newLayerCommand = new NewLayerCommand(groupLayer, parent, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(newLayerCommand, false);
                }

                // 対象レイヤーを削除する
                for(var i = 0; i < selectedLayers.length; ++i)
                {
                    var parentOfSelect = this.currentDesign.getParentLayer(selectedLayers[i]);
                    if(parentOfSelect != null)
                    {
                        var removeCommand = new DeleteLayerCommand(selectedLayers[i], parentOfSelect, this.currentDesign, () => {});
                        this.currentDesign.undoRedoManager.doAsMultiCommand(removeCommand, false);
                    }
                }

                this.fixMultiCommand();

                // カレントレイヤーが変わる場合は変形モードリセット
                this.changeEditMode(0);
            }
        }

        return canExecute;
    }

    // 選択レイヤーのグループ化解除
    private ungroupSelectedLayer(doCommand : boolean = true)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        var canExecute = false;

        var currentLayer = this.currentDesign.currentLayer;
        if(currentLayer != null && currentLayer instanceof GroupLayer && !currentLayer.isLocked)
        {
            canExecute = true;

            if(doCommand)
            {
                var parent = this.currentDesign.getParentLayer(currentLayer);
                if(parent == null) { parent = this.currentDesign.layer; }
                var currentIndex = parent.getLayerIndex(currentLayer);
                // グループ内のレイヤーを親グループに追加
                // 逆順に入れないと、順序が入れ替わる
                for(var i = currentLayer.getLayerCount() - 1; i >= 0; --i)
                {
                    var layer = currentLayer.getLayer(i).clone();
                    var insertLayerCommand = new InsertLayerCommand(layer, parent, currentIndex, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(insertLayerCommand, false);
                }
                // グループレイヤーを削除
                var deleteLayerCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(deleteLayerCommand, true);
            }
        }

        return canExecute;
    }

    // 表レイヤーのセル情報変更
    private changeTableCellInfo(layer : TableLayer, propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangeTableCellInfoCommand(layer, layer.currentRow, layer.currentColumn, propertyName, value, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // 表レイヤーのすべてのセル情報変更
    private changeAllTableCellInfo(layer : TableLayer, propertyName : string, value : any, isFinish : boolean)
    {
        for(var r = 0; r < layer.row; ++r)
        {
            for(var c = 0; c < layer.column; ++c)
            {
                var command = new ChangeTableCellInfoCommand(layer, r, c, propertyName, value, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(command, false);
            }
        }
        if(isFinish)
        {
            this.fixMultiCommand();
        }
    }

    // 表レイヤーのセル情報変更(セル指定)
    private changeTableCellInfoByCell(layer : TableLayer, row : number, column : number, propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangeTableCellInfoCommand(layer, row, column, propertyName, value, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // 表レイヤーのセル高さ変更
    private changeTableCellHeight(layer : TableLayer, value : number, isFinish : boolean)
    {
        var row = layer.currentRow;
        // 今の該当セルの高さ(mm)
        var rowHeight = layer.getCellInfo(row, 0).cellHeightNormalized * layer.height / 100;
        // 新しい値との差
        var delta = value - rowHeight;
        // 新しい高さ
        var newHeight = layer.height + delta;
        // 新しい高さに対して、すべてのセルの高さを再計算する
        for(var r = 0; r < layer.row; ++r)
        {
            for(var c = 0; c < layer.column; ++c)
            {
                var newCellHeight = r == row ? value : layer.getCellInfo(r, c).cellHeightNormalized * layer.height / 100;
                var newCellHeightNomalized = newCellHeight / newHeight * 100;
                this.changeTableCellInfoByCell(layer, r, c, "cellHeightNormalized", newCellHeightNomalized, false, false);
            }
        }

        // 高さを更新する
        this.resizeLayer(layer, layer.width, newHeight, isFinish);
    }

    // 表レイヤーのセル幅変更
    private changeTableCellWidth(layer : TableLayer, value : number, isFinish : boolean)
    {
        var column = layer.currentColumn;
        // 今の該当セルの幅(mm)
        var columnWidth = layer.getCellInfo(0, column).cellWidthNormalized * layer.width / 100;
        // 新しい値との差
        var delta = value - columnWidth;
        // 新しい幅
        var newWidth = layer.width + delta;
        // 新しい幅に対して、すべてのセルの幅を再計算する
        for(var r = 0; r < layer.row; ++r)
        {
            for(var c = 0; c < layer.column; ++c)
            {
                var newCellWidth = c == column ? value : layer.getCellInfo(r, c).cellWidthNormalized * layer.width / 100;
                var newCellWidthNomalized = newCellWidth / newWidth * 100;
                this.changeTableCellInfoByCell(layer, r, c, "cellWidthNormalized", newCellWidthNomalized, false, false);
            }
        }

        // 幅を更新する
        this.resizeLayer(layer, newWidth, layer.height, isFinish);
    }

    // 表レイヤーのセル追加
    private addTableCell(layer : TableLayer, direction : number)
    {
        // カレントがない場合は最終セル
        var row = layer.currentRow >= 0 ? layer.currentRow : layer.row - 1
        var column = layer.currentColumn >= 0 ? layer.currentColumn : layer.column - 1;

        var command = new AddTableCellCommand(layer, row, column, direction, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // 表レイヤーのセル削除
    private deleteTableCell(layer : TableLayer, isDeleteRow : boolean, isDeleteColumn : boolean)
    {
        // 行・列はそれぞれ0にできない
        if(isDeleteRow && layer.row <= 1) { return; }
        if(isDeleteColumn && layer.column <= 1) { return; }

        // カレントがない場合は最終セル
        var row = layer.currentRow >= 0 ? layer.currentRow : layer.row - 1
        var column = layer.currentColumn >= 0 ? layer.currentColumn : layer.column - 1;

        var command = new DeleteTableCellCommand(layer, row, column, isDeleteRow, isDeleteColumn, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // 表レイヤーのセル色適用
    private applyCellColor(layer : TableLayer, isRow : boolean, isColumn : boolean)
    {
        // カレントがない場合は最終セル
        var row = layer.currentRow >= 0 ? layer.currentRow : layer.row - 1
        var column = layer.currentColumn >= 0 ? layer.currentColumn : layer.column - 1;

        // 色取得
        var color = layer.getCellInfo(row, column).backgroundColor;

        if(isRow)
        {
            // 同じ行にあるセルについて色変更
            for(var c = 0; c < layer.column; ++c)
            {
                this.changeTableCellInfoByCell(layer, row, c, "backgroundColor", color.clone(), false, false);
            }
        }
        if(isColumn)
        {
            // 同じ列にあるセルについて色変更
            for(var r = 0; r < layer.row; ++r)
            {
                this.changeTableCellInfoByCell(layer, r, column, "backgroundColor", color.clone(), false, false);
            }
        }

        this.fixMultiCommand();
    }

    // 連番レイヤー作成
    private createNumberLayer(parent : GroupLayer, name : string, x : number, y : number, width : number, height : number)
    {
        var newLayer = NumberLayer.create(this.currentDocument, x, y, width, height);
        // 文字列が入るボックスの縦横比
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        // 0のときのサイズで初期化される
        var text = newLayer.getText();
        var size = canvasWindow.calcTextSize(text, 64, false, false, false);
        var scale = size.height / size.width;
        newLayer.height = newLayer.width * scale;
        newLayer.y = (this.currentDesign.height - newLayer.height) / 2;
        newLayer.name = name;

        var command : NewLayerCommand = new NewLayerCommand(newLayer, parent, this.currentDesign, () => {});
		this.currentDesign.undoRedoManager.do(command);
    }

    // 複数レイヤーの移動
    private moveMultipleLayers(layers : Array<Layer>, deltaX : number, deltaY : number, isFinish : boolean)
    {
        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];
            var newX = layer.x + deltaX;
            var newY = layer.y + deltaY;
            this.transformLayer(layer, newX, newY, layer.width, layer.height, layer.rotate, false);
        }
        if(isFinish)
        {
            this.fixMultiCommand();
        }
    }

    // 複数レイヤーのプロパティ変更
    private changeMultipleLayersProperty(layers : Array<Layer>, propertyName : string, value : any, isFinish : boolean)
    {
        for(var i = 0; i < layers.length; ++i)
        {
            this.changeLayerProperty(layers[i], propertyName, value, false, false);
        }
        if(isFinish)
        {
            this.fixMultiCommand();
        }
    }

    // レイヤーの水平方向整列
    private alignLayerHorizontal(layer : Layer, alignment : string)
    {
        // ロックされてると無効
        if(layer.isLocked) { return; }

        // レイヤーの外接矩形
        var bounds = layer.getBoundingRect();
        // 移動差分
        var deltaX = 0;

        if(alignment == "left")
        {
            // 左
            deltaX = -bounds.x;
        }
        else if(alignment == "center" || alignment == "even")
        {
            // 中央 or 均等
            deltaX = (this.currentDesign.width - bounds.width) / 2 - bounds.x;

        }
        else if(alignment == "right")
        {
            // 右
            deltaX = this.currentDesign.width - bounds.width - bounds.x;
        }

        if(!MathHelper.equals(deltaX, 0))
        {
            // 移動する
            this.moveLayer(layer, layer.x + deltaX, layer.y, true);
        }
    }

    // レイヤーの垂直方向整列
    private alignLayerVertical(layer : Layer, alignment : string)
    {
        // ロックされてると無効
        if(layer.isLocked) { return; }

        // レイヤーの外接矩形
        var bounds = layer.getBoundingRect();
        // 移動差分
        var deltaY = 0;

        if(alignment == "top")
        {
            // 上
            deltaY = -bounds.y;
        }
        else if(alignment == "center" || alignment == "even")
        {
            // 中央 or 均等
            deltaY = (this.currentDesign.height - bounds.height) / 2 - bounds.y;

        }
        else if(alignment == "bottom")
        {
            // 下
            deltaY = this.currentDesign.height - bounds.height - bounds.y;
        }

        if(!MathHelper.equals(deltaY, 0))
        {
            // 移動する
            this.moveLayer(layer, layer.x, layer.y + deltaY, true);
        }
    }

    // 複数レイヤーの水平揃え
    private alignMultiLayersHorizontal(layers : Array<Layer>, alignment : string, fix : boolean = true, doCommand = true)
    {
        var canExecute = false;

        // 全レイヤーの外接矩形
        var allBounds = this.getMultiLayersBounds(layers);
        // ロックレイヤーを外したレイヤー
        var layersWithoutLocked : Array<Layer> = new Array();
        // レイヤーの外接矩形の合計
        var boundsSum = 0;
        for(var i = 0; i < layers.length; ++i)
        {
            if(layers[i].isLocked) { continue; }
            layersWithoutLocked.push(layers[i]);
            boundsSum += layers[i].getBoundingRect().width;
        }
        if(layersWithoutLocked.length > 0)
        {
            if(doCommand)
            {
                if(alignment == "even" && layersWithoutLocked.length > 1 )
                {
                    // 均等揃え
                    // レイヤーを水平外接矩形が左にある順にソートする。
                    var sortedLayers = ArrayHelper.orderby(layersWithoutLocked, (l) => l.getBoundingRect().x);
                    // 均等配置する間隔
                    var distance = (allBounds.width - boundsSum) / (layersWithoutLocked.length - 1);
                    // 配置し直し
                    for(var i = 0; i < sortedLayers.length; ++i)
                    {
                        if(i == 0) { continue; }

                        // 新しい外接矩形のx座標
                        var newBoundsX = sortedLayers[i - 1].getBoundingRect().right + distance;
                        var targetLayer = sortedLayers[i];
                        var deltaX = newBoundsX - targetLayer.getBoundingRect().x;
                        if(!MathHelper.equals(deltaX, 0))
                        {
                            // 移動する
                            this.moveLayer(targetLayer, targetLayer.x + deltaX, targetLayer.y, false);
                        }
                    }
                }
                else
                {
                    if(layersWithoutLocked.length <= 1)
                    {
                        // 対象のレイヤーが1つの場合は、基準矩形をデザインとする
                        allBounds.x = 0;
                        allBounds.y = 0;
                        allBounds.width = this.currentDesign.width;
                        allBounds.height = this.currentDesign.height;
                    }
                    for(var i = 0; i < layers.length; ++i)
                    {
                        var layer = layers[i];
                        // ロックされていたら対象外
                        if(layer.isLocked) { continue; }

                        var bounds = layer.getBoundingRect();
                        var deltaX = 0;
                        if(alignment == "left")
                        {
                            // 左
                            deltaX = allBounds.x - bounds.x;
                        }
                        else if(alignment == "center" || alignment == "even")
                        {
                            // 中央 or 均等
                            deltaX = (2 * allBounds.x + allBounds.width - bounds.width) / 2 - bounds.x;
                        }
                        else if(alignment == "right")
                        {
                            // 右
                            deltaX = allBounds.x + allBounds.width - bounds.width - bounds.x;
                        }

                        if(!MathHelper.equals(deltaX, 0))
                        {
                            // 移動する
                            this.moveLayer(layer, layer.x + deltaX, layer.y, false);
                        }
                    }
                }

                // コマンド確定
                if(fix) { this.fixMultiCommand(); }
            }
            canExecute = true;
        }

        return canExecute;
    }

    // 複数レイヤーの垂直揃え
    private alignMultiLayersVertical(layers : Array<Layer>, alignment : string, fix = true, doCommand = true)
    {
        var canExecute = false;

        // 全レイヤーの外接矩形
        var allBounds = this.getMultiLayersBounds(layers);
        // ロックレイヤーを外したレイヤー
        var layersWithoutLocked : Array<Layer> = new Array();
        // レイヤーの外接矩形の合計
        var boundsSum = 0;
        for(var i = 0; i < layers.length; ++i)
        {
            if(layers[i].isLocked) { continue; }
            layersWithoutLocked.push(layers[i]);
            boundsSum += layers[i].getBoundingRect().height;
        }
        if(layersWithoutLocked.length > 0)
        {
            if(doCommand)
            {
                if(alignment == "even" && layersWithoutLocked.length > 1)
                {
                    // 均等揃え
                    // レイヤーを水平外接矩形が上にある順にソートする。
                    var sortedLayers = ArrayHelper.orderby(layersWithoutLocked, (l) => l.getBoundingRect().y);
                    // 均等配置する間隔
                    var distance = (allBounds.height - boundsSum) / (layersWithoutLocked.length - 1);
                    // 配置し直し
                    for(var i = 0; i < sortedLayers.length; ++i)
                    {
                        if(i == 0) { continue; }

                        // 新しい外接矩形のy座標
                        var newBoundsY = sortedLayers[i - 1].getBoundingRect().bottom + distance;
                        var targetLayer = sortedLayers[i];
                        var deltaY = newBoundsY - targetLayer.getBoundingRect().y;
                        if(!MathHelper.equals(deltaY, 0))
                        {
                            // 移動する
                            this.moveLayer(targetLayer, targetLayer.x, targetLayer.y + deltaY, false);
                        }
                    }
                }
                else
                {
                    if(layersWithoutLocked.length <= 1)
                    {
                        // 対象のレイヤーが1つの場合は、基準矩形をデザインとする
                        allBounds.x = 0;
                        allBounds.y = 0;
                        allBounds.width = this.currentDesign.width;
                        allBounds.height = this.currentDesign.height;
                    }
                    for(var i = 0; i < layers.length; ++i)
                    {
                        var layer = layers[i];
                        // ロックされていたら対象外
                        if(layer.isLocked) { continue; }

                        var bounds = layer.getBoundingRect();
                        var deltaY = 0;
                        if(alignment == "top")
                        {
                            // 上
                            deltaY = allBounds.y - bounds.y;
                        }
                        else if(alignment == "center" || alignment == "even")
                        {
                            // 中央 or 均等
                            deltaY = (2 * allBounds.y + allBounds.height - bounds.height) / 2 - bounds.y;
                        }
                        else if(alignment == "bottom")
                        {
                            // 下
                            deltaY = allBounds.y + allBounds.height - bounds.height - bounds.y;
                        }

                        if(!MathHelper.equals(deltaY, 0))
                        {
                            // 移動する
                            this.moveLayer(layer, layer.x, layer.y + deltaY, false);
                        }
                    }
                }
                // コマンド確定
                if(fix) { this.fixMultiCommand(); }
            }
            canExecute = true;
        }

        return canExecute;
    }

    // 複数レイヤーの外接矩形
    // isLockedLayerIqnored : ロックレイヤーを含めない
    private getMultiLayersBounds(layers : Array<Layer>, isLockedLayerIqnored = true)
    {
        var minX = 0;
        var minY = 0;
        var maxX = 0;
        var maxY = 0;
        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];
            if(isLockedLayerIqnored && layer.isLocked) { continue; }
            var bounds = layer.getBoundingRect();
            minX = i == 0 ? bounds.x : Math.min(bounds.x, minX);
            minY = i == 0 ? bounds.y : Math.min(bounds.y, minY);
            maxX = i == 0 ? bounds.x + bounds.width : Math.max(bounds.x + bounds.width, maxX);
            maxY = i == 0 ? bounds.y + bounds.height : Math.max(bounds.y + bounds.height, maxY);
        }

        return new Rectangle(minX, minY, maxX - minX, maxY - minY);
    }

    // レイヤーのトリミング
    private trimLayer(layer : Layer, x : number, y : number, width : number, height : number, isFinish = false)
    {
        // ロックのとき無効
        if(layer.isLocked) { return; }
        // ImageLayerのみ
        if(!(layer instanceof ImageLayer)) { return; }
        var newTrimRect = new Rectangle(x, y, width, height);
        // プロパティ変更
        if(!layer.isTrim)
        {
            // トリム無効の場合は有効にする
            this.changeLayerProperty(layer, "isTrim", true, false, false);
        }
        this.changeLayerProperty(layer, "trimRectNormalized", newTrimRect, isFinish, false);
    }

    // レイヤーのクリップ形状変更
    private changeLayerClipShape(layer : Layer, pattern : number, corner : number)
    {
        // ロックのとき無効
        if(layer.isLocked) { return; }
        // ImageLayerのみ
        if(!(layer instanceof ImageLayer)) { return; }

        // 形状取得
        var isClip = false;
        var svgPath = "";
        if(pattern == 0 && corner == 0)
        {
            // 矩形の場合はクリップなし
            isClip = false;
            svgPath = "";
        }
        else
        {
            // 形状取得
            isClip = true;
            // サイズ基準は100 x 100, 自動高さ変更は行わない
            var outHeight = { height : 0 };
            svgPath = PathHelper.createPattern(pattern, corner, 0, 0, 100, 100, 0, 0, 0, false, outHeight);
        }

        // レイヤープロパティ変更
        this.changeLayerProperty(layer, "isTrim", true, false, false);
        this.changeLayerProperty(layer, "isClip", isClip, false, false);
        this.changeLayerProperty(layer, "clipShapeSvgPath", svgPath, true, false);
    }

    // デザインの書き出し
    private exportDesign(quality : number, isClipLayer : boolean, fileType : string)
    {
        // レンダリング開始
        this.startRendering(quality, isClipLayer);
        // Rendererの表示を待つ
        this.$nextTick(() => {
            var renderer = this.$refs.designrenderer;
            if(renderer != null && renderer instanceof DesignRenderer) {
                if (UserAgentHelper.isElectron()) {
                    // Electronにサムネイルの生成を任せる
	                const xml = (new XMLSerializer()).serializeToString(renderer.getSvgElement());
                    const blob = new Blob([xml], {type: 'image/svg+xml'});
                    const type = fileType === 'jpg' ? 'jpg' : 'png';
                    const url = `${URL.createObjectURL(blob)}?op=design&width=${renderer.viewWidth}&height=${renderer.viewHeight}&type=${type}`;
                    window.open(url);
                } else {
                    const params = renderer.getSvgImage();
                    ImageHelper.svg2png(params.image, params.width, params.height, png => {
                        if(fileType == "jpg") {
                            // jpgに変換して保存する
                            ImageHelper.png2jpg(png, jpg => {
                                FileHelper.saveImage(jpg, "jpg", "output.jpg");
                            });
                        } else {
                            // pngのまま保存する
                            FileHelper.saveImage(png, "png", "output.png");
                        }
                    });
                }
            }
            // レンダリング終了
            this.endRendering();
        });
    }

    // テンプレートの差し替え
    private replaceTemplate()
    {
        // テンプレート選択に遷移する
        this.goLink("/SelectTemplate", false);
    }

    // 画像の読み込み
    private importImage(imageBase64 : string, imageWhiteTransparent : string, imageWidth : number, imageHeight : number, isSvg : boolean)
    {
        if(imageWidth <= 0 || imageHeight <= 0 || imageBase64 == "" || imageWhiteTransparent == "") return;

        // 半分のサイズに調整する
        const halfCanvas = { width: this.currentDesign.width / 2, height: this.currentDesign.height / 2 };
        const { width, height } = ImageHelper.fitImageSize({ width: imageWidth, height: imageHeight }, halfCanvas);
        var x = (this.currentDesign.width - width) / 2;
        var y = (this.currentDesign.height - height) / 2;

        // イメージのインポート処理定義
        var process = (imageBase64Resized : string, imageWhiteTransparentResized : string, newWidth : number, newHeight : number, newIsSvg : boolean) =>
        {
            var layer;
            if (newIsSvg) {
                // ベクター画像レイヤー作成
                layer = VectorImageLayer.create(imageBase64Resized, x, y, width, height);
            } else {
                // ラスター画像レイヤー作成
                layer = RasterImageLayer.create(imageBase64Resized, x, y, width, height);
            }
            // レイヤーに白色透明を追加
            layer.setWhiteTransparentImage(imageWhiteTransparentResized);
            // サイズを設定
            layer.imageWidth = newWidth;
            layer.imageHeight = newHeight;
            // 名前
            layer.name = NameHelper.createLayerName("image", this.currentDesign);
            var parent = this.getParentGroupLayer();

            // サムネイル画像を作成する
            let widthScale = newWidth / newHeight;
            let heightScale = newHeight / newWidth;
            let thumbnailImageWidth = widthScale < 1.0 ? 320 * widthScale : 320;
            let thumbnailImageHeight = heightScale < 1.0 ? 320 * heightScale : 320;
            if(thumbnailImageWidth > newWidth) { thumbnailImageWidth = newWidth; thumbnailImageHeight = newHeight; }
            ImageHelper.resizeImage(imageBase64Resized, thumbnailImageWidth, thumbnailImageHeight, (thumb) =>{
                layer.thumbnailImage = thumb;
                ImageHelper.resizeImage(imageWhiteTransparentResized, thumbnailImageWidth, thumbnailImageHeight, (thumbWT) => {
                    layer.thumbnailImageWhiteTransparent = thumbWT;
                    // 新規レイヤー作成
                    this.newLayer(layer, parent);
                });
            });
        };

        // 適用前にサイズチェックする
        if(isSvg)
        {
            // SVGの場合は、白色透明化画像のほうが大きいので、こちらでサイズチェックする
            ImageHelper.getImageSize(imageWhiteTransparent, size =>
            {
                this.resizeImageIfNeeded(imageBase64, imageWhiteTransparent, size.width, size.height, this.currentDesign.width, this.currentDesign.height, isSvg, process);
            });
        }
        else
        {
            this.resizeImageIfNeeded(imageBase64, imageWhiteTransparent, imageWidth, imageHeight, this.currentDesign.width, this.currentDesign.height, isSvg, process);
        }
    }

    // イメージリサイズの判定と、リサイズ後の処理を行う
    private resizeImageIfNeeded(imageBase64 : string, imageWhiteTransparent : string, imageWidth : number, imageHeight : number, dstWidth : number, dstHeight : number, isSvg : boolean,
        completion : (imageBase64Resized : string, imageWhiteTransparentResized : string, newWidth : number, newHeight : number, newIsSvg : boolean) => void)
    {
        // サイズチェック
        if(ImageHelper.isImageSizeTooMuch(imageWidth, imageHeight, dstWidth, dstHeight))
        {
            // サイズが大きすぎる
            var alert = this.$refs.largeImageAlert as LargeImageAlert;
            alert.open((button) =>
            {
                if(button == "origin")
                {
                    // そのまま
                    completion(imageBase64, imageWhiteTransparent, imageWidth, imageHeight, isSvg);
                }
                else if(button == "resize")
                {
                    // リサイズ
                    // 適切なサイズを取得する
                    var newSize = ImageHelper.calcProperSize(imageWidth, imageHeight, dstWidth, dstHeight);
                    // 白色透明化はラスターなので必ずリサイズ
                    ImageHelper.resizeImage(imageWhiteTransparent, newSize.width, newSize.height, imageWhiteTransparentResized =>
                    {
                        DebugHelper.trace("WhiteTransparentImage resized to width " + newSize.width + " height " + newSize.height);
                        if(isSvg)
                        {
                            // SVG画像はピクセルが関係ないので、元画像のリサイズしない
                            completion(imageBase64, imageWhiteTransparentResized, imageWidth, imageHeight, isSvg);
                        }
                        else
                        {
                            // 元画像のリサイズ
                            ImageHelper.resizeImage(imageBase64, newSize.width, newSize.height, imageBaseResized =>
                            {
                                DebugHelper.trace("Image resized to width " + newSize.width + " height " + newSize.height);
                                completion(imageBaseResized, imageWhiteTransparentResized, newSize.width, newSize.height, false);
                            });
                        }
                    });
                }
            });
        }
        else
        {
            // サイズが問題ない
            completion(imageBase64, imageWhiteTransparent, imageWidth, imageHeight, isSvg);
        }
    }

    private getParentGroupLayer()
    {
        // 基本はデザインのトップ
        var parent = this.currentDesign.layer as GroupLayer;
        var currentLayer = this.currentDesign.currentLayer;
        if (currentLayer != null)
        {
            if (currentLayer instanceof GroupLayer)
            {
                // カレントがグループの場合はそのレイヤー
                parent = currentLayer;
            }
            else
            {
                // カレントがある場合はその親レイヤー
                var parentOfCurrent = this.currentDesign.getParentLayer(currentLayer);
                if (parentOfCurrent != null) parent = parentOfCurrent;
            }
        }
        return parent;
    }

    // 画像の差し替え
    private replaceImage(layer : Layer, image : string, imageWhiteTransparent : string, imageWidth : number, imageHeight : number, isSvg : boolean)
    {
        // ロックのとき無効
        if(layer.isLocked) { return; }
        // 画像レイヤーで、また画像が正常な時のみ
        if(!(layer instanceof ImageLayer) || imageWidth <= 0 || imageHeight <= 0 || image == "" || imageWhiteTransparent == "") { return; }

        // イメージの差し替え処理定義
        var process = (imageBase64Resized : string, imageWhiteTransparentResized : string, newWidth : number, newHeight : number, newIsSvg : boolean) =>
        {
            // 差し替え用レイヤーを生成する
            var replacedLayer;
            if(newIsSvg)
            {
                replacedLayer = VectorImageLayer.createImageReplacedLayer(layer, imageBase64Resized, imageWhiteTransparentResized, newWidth, newHeight);
            }
            else
            {
                replacedLayer = RasterImageLayer.createImageReplacedLayer(layer, imageBase64Resized, imageWhiteTransparentResized, newWidth, newHeight);
            }
            // 元のレイヤーの親
            var parent = this.currentDesign.getParentLayer(layer);
            if(parent != null)
            {
                // 元のレイヤーのインデックス
                var index = parent.getLayerIndex(layer);
                // レイヤー削除
                var deleteLayerCommand = new DeleteLayerCommand(layer, parent, this.currentDesign, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(deleteLayerCommand, false);
                // レイヤー挿入
                var insertLayerCommand = new InsertLayerCommand(replacedLayer, parent, index, this.currentDesign, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(insertLayerCommand, true);
            }
        }

        // 適用前にサイズチェックする
        if(isSvg)
        {
            // SVGの場合は、白色透明化画像のほうが大きいので、こちらでサイズチェックする
            ImageHelper.getImageSize(imageWhiteTransparent, size =>
            {
                this.resizeImageIfNeeded(image, imageWhiteTransparent, size.width, size.height, this.currentDesign.width, this.currentDesign.height, isSvg, process);
            });
        }
        else
        {
            this.resizeImageIfNeeded(image, imageWhiteTransparent, imageWidth, imageHeight, this.currentDesign.width, this.currentDesign.height, isSvg, process);
        }
    }

    // プロフィール挿入
    private insertProfile(data : ProfileData)
    {
        var command = new InsertProfileCommand(data, this.currentDesign, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // テキストの編集確定
    private fixText()
    {
        // マルチコマンド確定
        this.fixMultiCommand();

        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        if(canvasWindow != null)
        {
            canvasWindow.isTextInEdit = false;
        }
    }

    // 全レイヤーを選択
    private selectAllLayers(doCommand = true)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        var canExecute = false;
        // グループを含めた全オブジェクト
        var allLayers = this.currentDesign.getAllLayers(true);

        if(allLayers.length > 0)
        {
            if(doCommand)
            {
                this.currentDesign.clearSelectLayers();

                for(var i = 0; i < allLayers.length; ++i)
                {
                    var layer = allLayers[i];
                    if(!layer.isLocked)
                    {
                        // ロック状態ではないときは追加
                        this.currentDesign.addSelectLayer(layer);
                    }
                }
            }

            canExecute = true;
        }

        return canExecute;
    }

    // レイヤーの選択を解除
    private unselectAllLayers(doCommand = true)
    {
        var canExecute = false;

        if(this.currentDesign.selectLayers.length > 0)
        {
            if(doCommand)
            {
                // テキスト編集確定
                if(this.isInTextEdit()) this.fixText();
                this.currentDesign.clearSelectLayers();
            }
            canExecute = true;
        }

        return canExecute;
    }

    // レイヤーロック切り替え
    private switchLockLayer(doCommand = true)
    {
        var canExecute = false;

        var selectedLayers = this.currentDesign.selectLayers;
        if(selectedLayers.length > 0)
        {
            if(doCommand)
            {
                for(var i = 0; i < selectedLayers.length; ++i)
                {
                    var layer = selectedLayers[i];
                    var isLocked = layer.isLocked;
                    var lockCommand = new ChangeLayerPropertyCommand(layer, "isLocked", !isLocked, () => {} );
                    this.currentDesign.undoRedoManager.doAsMultiCommand(lockCommand, false);
                }

                this.fixMultiCommand();
            }
            canExecute = true;
        }

        return canExecute;
    }

    // グループレイヤー切り替え
    private switchGroupLayer(doCommand = true)
    {
        // グループ化かグループ解除か判定する
        // グループを解除する条件は
        // 1. 選択レイヤーがただ一つ
        // 2. カレントレイヤーがグループレイヤー
        var currentLayer = this.currentDesign.currentLayer;
        if(this.currentDesign.selectLayers.length == 1 && currentLayer != null && currentLayer.layerType == "group")
        {
            // グループ解除
            return this.ungroupSelectedLayer(doCommand);
        }
        else
        {
            // グループ化
            return this.groupSelectedLayer(doCommand);
        }
    }

    // レイヤーを最前面に
    private bringToFrontCurrentLayer(doCommand = true)
    {
        var canExecute = false;

        var currentLayer = this.currentDesign.currentLayer;
        if(currentLayer != null)
        {
            var parent = this.currentDesign.getParentLayer(currentLayer);
            var top = this.currentDesign.layer;
            if(parent != null && top != null && top instanceof GroupLayer)
            {
                if(doCommand)
                {
                    // レイヤーをいったん削除する
                    var deleteCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {} );
                    this.currentDesign.undoRedoManager.doAsMultiCommand(deleteCommand, false);
                    // レイヤーを最前面に追加する
                    var newLayerCommand = new NewLayerCommand(currentLayer, top, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(newLayerCommand, true);
                }
                canExecute = true;
            }
        }

        return canExecute;
    }

    // レイヤーを最背面に
    private sendToBackCurrentLayer(doCommand = true)
    {
        var canExecute = false;

        var currentLayer = this.currentDesign.currentLayer;
        if(currentLayer != null)
        {
            var parent = this.currentDesign.getParentLayer(currentLayer);
            var top = this.currentDesign.layer;
            if(parent != null && top != null && top instanceof GroupLayer)
            {
                if(doCommand)
                {
                    // レイヤーをいったん削除する
                    var deleteCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {} );
                    this.currentDesign.undoRedoManager.doAsMultiCommand(deleteCommand, false);
                    // レイヤーを最背面に追加する
                    var insertLayerCommand = new InsertLayerCommand(currentLayer, top, 0, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(insertLayerCommand, true);
                }
                canExecute = true;
            }
        }

        return canExecute;
    }

    // 選択レイヤーの階層を一つ入れ替え
    // direction : up / down
    private orderLayer(direction : string, doCommand = true)
    {
        var canExecute = false;

        // 対象はカレントレイヤー
        var currentLayer = this.currentDesign.currentLayer;
        if(currentLayer != null)
        {
            var parent = this.currentDesign.getParentLayer(currentLayer);
            if(parent == null) { return; }
            // 一つ上の階層のレイヤー
            var upperLayer = LayerHelper.getUpperLayer(currentLayer, this.currentDesign);
            // 一つ下の階層のレイヤー
            var lowerLayer = LayerHelper.getLowerLayer(currentLayer, this.currentDesign);

            if(direction == "up")
            {
                if(upperLayer != null)
                {
                    var parentOfUpper = this.currentDesign.getParentLayer(upperLayer);
                    if(parentOfUpper != null)
                    {
                        if(doCommand)
                        {
                            var upperIndex = parentOfUpper.getLayerIndex(upperLayer);
                            // レイヤーをいったん削除する
                            var deleteCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {} );
                            this.currentDesign.undoRedoManager.doAsMultiCommand(deleteCommand, false);
                            // レイヤーを一つ上に追加する
                            var insertCommand = new InsertLayerCommand(currentLayer, parentOfUpper, upperIndex, this.currentDesign, () => {});
                            this.currentDesign.undoRedoManager.doAsMultiCommand(insertCommand, true);
                        }

                        canExecute = true;
                    }
                }
            }
            else
            {
                if(lowerLayer != null)
                {
                    var parentOfLower = this.currentDesign.getParentLayer(lowerLayer);
                    if(parentOfLower != null)
                    {
                        if(doCommand)
                        {
                            var lowerIndex = parentOfLower.getLayerIndex(lowerLayer);
                            // レイヤーをいったん削除する
                            var deleteCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {} );
                            this.currentDesign.undoRedoManager.doAsMultiCommand(deleteCommand, false);
                            // レイヤーを一つ下に追加する
                            var insertCommand = new InsertLayerCommand(currentLayer, parentOfLower, lowerIndex, this.currentDesign, () => {});
                            this.currentDesign.undoRedoManager.doAsMultiCommand(insertCommand, true);
                        }

                        canExecute = true;
                    }
                }
            }
        }

        return canExecute;
    }

    // 選択レイヤーの整列
    // direction : "horizontal" "vertical" "both"
    private alignSelectedLayers(direction : string, alignment : string, doCommand = true)
    {
        var canExecute = false;

        var selectedLayers = this.currentDesign.selectLayers;
        if(direction == "both")
        {
            var result1 = this.alignMultiLayersHorizontal(selectedLayers, alignment, false, doCommand);
            var result2 = this.alignMultiLayersVertical(selectedLayers, alignment, false, doCommand);
            if(doCommand)
            {
                this.fixMultiCommand();
            }
            canExecute = result1 || result2;
        }
        else if(direction == "horizontal")
        {
            canExecute = this.alignMultiLayersHorizontal(selectedLayers, alignment, true, doCommand);
        }
        else if(direction == "vertical")
        {
            canExecute = this.alignMultiLayersVertical(selectedLayers, alignment, true, doCommand);
        }

        return canExecute;
    }

    // サブコントローラの表示切り替え
    private switchVisibleSubController(doCommand = true)
    {
        if(doCommand)
        {
            this.isSubControllerVisible ? this.closeSubController() : this.openSubController();
        }
        return true;
    }

    // ズーム自動切り替え
    private switchAutoZoom(doCommand = true)
    {
        if(doCommand)
        {
            this.isAutoZoom = !this.isAutoZoom;
        }
        return true;
    }

    // 新規ドキュメント
    private isSaveDesignModalVisible = false;
    private saveDesignModalCompletion = () => {};
    private createNewDocument(doCommand = true)
    {
        if(doCommand)
        {
            let completion = () =>
            {
                // フローを通常にする
                this.$store.getters.applicationState.flowMode == 0;

                // 用紙選択に遷移
                this.$router.push("/SelectPage");
            }

            // TODO 本来は編集フラグを見ること。
            if(this.currentDesign.hasAnyObject())
            {
                // 保存させるか選択するモーダルを表示する
                this.isSaveDesignModalVisible = true;
                // 完了時の処理
                this.saveDesignModalCompletion = () =>
                {
                    completion();
                };
            }
            else
            {
                completion();
            }
        }

        return true;
    }

    // 保存モーダルのコールバック
    private saveDesignModalCallback(button : string)
    {
        if(button == "save")
        {
            this.saveDocument();
        }

        // 完了処理
        this.saveDesignModalCompletion();
    }

    // ショートカットの有効・無効化
    private enableShortcut(isEnable : boolean)
    {
        this.isShorcutDisabled = !isEnable;
    }

    private get currentTab() { return "/DesignEditor"; }

    isSubControllerVisible : boolean = true;


    closeSubController(){
        this.isSubControllerVisible = false;
        CookieHelper.setItem("isSubControllerVisible" , false)
    }

    openSubController(){
        this.isSubControllerVisible = true;
        CookieHelper.setItem("isSubControllerVisible" , true)
    }

    private closeLicense(){
        this.isLicense = false;
        this.isTutorial = CookieHelper.getItem("designEditorTutorial") != true;
    }

    private closeIeAlertModal(){
        this.isIeAlertModal = false;
        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else{
            this.isTutorial = CookieHelper.getItem("designEditorTutorial") != true;
        }
    }
}
